(function () {
  'use strict';

  // Safari "Alle Cookies blockieren" (und manche In-App-WebViews) werfen
  // bereits beim ZUGRIFF auf window.localStorage eine SecurityError — ein
  // einziger ungeschützter Zugriff killt das ganze Script und lässt die
  // Seite tot zurück. Fallback auf einen In-Memory-Store, damit die App
  // innerhalb der Sitzung weiter funktioniert.
  var localStore = (function () {
    try {
      var s = window.localStorage;
      s.setItem('__tt_probe', '1'); s.removeItem('__tt_probe');
      return s;
    } catch (e) {
      var mem = {};
      return {
        getItem: function (k) { return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; },
        setItem: function (k, v) { mem[k] = String(v); },
        removeItem: function (k) { delete mem[k]; }
      };
    }
  })();

  var TT_LOCALE = (function () {
    try {
      var html = document.documentElement.lang;
      if (html) {
        if (/^de\b/i.test(html)) return 'de-CH';
        if (/^fr\b/i.test(html)) return 'fr-CH';
        if (/^it\b/i.test(html)) return 'it-CH';
        if (/^en\b/i.test(html)) return 'en-CH';
        return html;
      }
    } catch (e) {}
    return 'de-CH';
  })();

  // ============================================================
  // CONFIG
  // ============================================================

  var API_BASE = 'https://api.loopsubscriptions.com/storefront/2023-10';
  var SUPABASE_FN_BASE = 'https://lcqtibhlyjqtifxhymvt.supabase.co/functions/v1';
  // Keep in-app redirects in the visitor's language (DE has no prefix, EN/FR
  // are served under /en and /fr) so logged-out EN/FR users are not bounced to
  // the German login mask. Prefer Shopify's locale-aware root; fall back to the
  // locale segment already present in the current URL.
  function ttLocaleRoot() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r && r !== '/') return '/' + r.replace(/^\/+|\/+$/g, '');
    } catch (e) {}
    var m = (window.location.pathname || '').match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/)/i);
    return m ? '/' + m[1].toLowerCase() : '';
  }
  function localized(p) {
    if (!p || p.charAt(0) !== '/' || p.charAt(1) === '/') return p;
    return ttLocaleRoot() + p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
  }
  var LOGIN_PATH = localized('/pages/login');

  // Google review (Tom Tasty Google Business profile) — the "rate us on Google"
  // flyover sends loyal, all-5-stars customers here.
  var GOOGLE_REVIEW_URL = 'https://g.page/r/CULVDzxKGCFWEBM/review';
  // A customer who picked "Vielleicht später" is re-asked only after this long.
  var GOOGLE_REVIEW_SNOOZE_MS = 28 * 24 * 60 * 60 * 1000; // 4 weeks
  // Das neue Tom Tasty (E-65): «Später» blendet die Umzugs-Karte so lange aus.
  var NEU_UMZUG_SPAETER_KEY = 'tt_neu_umzug_spaeter_bis';
  var NEU_UMZUG_SPAETER_MS = 7 * 24 * 60 * 60 * 1000;
  function neuUmzugVerschoben() {
    return Number(localStore.getItem(NEU_UMZUG_SPAETER_KEY) || 0) > Date.now();
  }
  // "mehr als 5 Bestellungen in den letzten 3 Monaten" — counted over this window.
  var GOOGLE_REVIEW_ORDER_WINDOW_MS = 90 * 24 * 60 * 60 * 1000; // ~3 months
  var GOOGLE_REVIEW_MIN_ORDERS = 5; // strictly MORE than this → ≥ 6

  // Quick-insert phrase catalog. Clicking a chip toggles its label into the
  // free-text note ("Notiz an die Küche"), separated by " · ". The chip set
  // depends on the star rating: 5 = positive, <5 = improvement.
  var REVIEW_POSITIVE_TAGS = ['well_seasoned', 'great_taste', 'filling', 'fresh', 'great_ingredients', 'perfect_size', 'would_reorder'];
  var REVIEW_IMPROVEMENT_TAGS = ['too_salty', 'bland', 'dry', 'portion_small', 'overcooked', 'undercooked', 'ingredients_quality'];
  var REVIEW_TAG_SEP = ' · ';

  // Only the 3 most recent PROCESSED orders are rateable. Older ones (and
  // skipped ones) render dish lists without state/CTA.
  var RATEABLE_ORDER_LIMIT = 3;
  var T = window.TT_I18N || { t: function (k) { return k; }, common: {}, cockpit: {}, winback: {} };

  var STORAGE = {
    accessToken: 'loopAccessToken',
    refreshToken: 'loopRefreshToken',
    // '1' while viewing via Loop admin impersonation (?merchantToken). Persisted
    // so the banner survives reloads / navigating back to the cockpit.
    merchantView: 'tt_merchant_view',
  };

  var WINBACK_OFFERS = {
    price: { badge: T.winback.price_badge, big: T.winback.price_big, title: T.winback.price_title, desc: T.winback.price_desc, cta: T.winback.price_cta },
    away: { badge: T.winback.away_badge, big: T.winback.away_big, title: T.winback.away_title, desc: T.winback.away_desc, cta: T.winback.away_cta },
    toomuch: { badge: T.winback.toomuch_badge, big: T.winback.toomuch_big, title: T.winback.toomuch_title, desc: T.winback.toomuch_desc, cta: T.winback.toomuch_cta },
    variety: { badge: T.winback.variety_badge, big: T.winback.variety_big, title: T.winback.variety_title, desc: T.winback.variety_desc, cta: T.winback.variety_cta },
    other: { badge: T.winback.other_badge, big: T.winback.other_big, title: T.winback.other_title, desc: T.winback.other_desc, cta: T.winback.other_cta }
  };

  // ============================================================
  // DOM
  // ============================================================

  var root = document.getElementById('tt-loop-cockpit');
  if (!root) return;
  var elLoading = document.getElementById('tt-cp-loading');
  var elContent = document.getElementById('tt-cp-content');
  var elError = document.getElementById('tt-cp-error');

  // ============================================================
  // STATE
  // ============================================================

  var state = {
    customer: null,
    subscription: null,
    paymentMethods: [],
    orders: [],
    scheduledOrders: [],
    profile: null,
    ordersExpanded: false,
    ordersPage: 1,
    dishPage: 1,
    deliveriesExpanded: false,
    pendingSkipOrderId: null,
    pauseWeeks: 1,
    cancelReason: null,
    // Cancellation reasons from Loop's GET /cancellationFlow + the selected one.
    cancelReasons: [],
    cancelReasonObj: null,
    // Reason box (skip/pause): context for the row we'll log + the picked option.
    reasonCtx: null,
    reasonChoice: null,
    // Per-delivery reviews keyed by (order_id, product_id). Loaded from
    // /functions/v1/my-reviews on boot; mutated in place on submit.
    reviews: [],
    openOrders: Object.create(null),
    activeReview: null,
    reviewQueue: null,
    // Ratings given during the CURRENT review-queue session, keyed by
    // "orderId|productId" (so re-rating a dish overwrites, not double-counts).
    // Used to detect an "all 5 stars" session → Google-review flyover.
    reviewSession: null,
    // Google-review prompt state for this customer, loaded from /google-review
    // on boot: { status: 'later'|'done', snooze_count, last_prompted_at } or null.
    googleReview: null,
    _googleReviewLoaded: false,
    // ?googleReviewPreview=1 — forces the Google flyover on load and makes its
    // buttons no-ops (no DB writes), so the flyover can be tested in isolation.
    googleReviewPreview: false,
    // Per-open guards for the Google flyover: preview = no DB writes; resolved =
    // an explicit choice was made (so closing doesn't double-log a "später").
    _googleReviewPreviewOpen: false,
    _googleReviewResolved: false,
    // True once /my-reviews has resolved — gates the "offene Bewertungen"
    // hint so it never flashes before we know what's actually rated.
    _reviewsLoaded: false,
    // Guards the one-time auto-scroll to past deliveries after returning from
    // the dish selector (?from=dishes) when reviews are still open.
    _reviewScrollHandled: false,
    // True when entered via Loop admin "Access customer portal"
    // (?merchantToken=…) — drives the impersonation banner.
    isMerchantView: false,
  };

  var PAGE_SIZE = 8;
  var DISH_PAGE_SIZE = 10;

  // ============================================================
  // TOKEN MANAGEMENT
  // ============================================================
  //
  // Token model (Loop Storefront API):
  //   sessionToken — entry token from a Klaviyo magic-link URL, 1-day lifetime.
  //                  Exchanged once for an (access, refresh) pair.
  //   accessToken  — JWT bearer, ~4-day lifetime, sent on every API call.
  //   refreshToken — rotates the access token, fixed 30-day lifetime
  //                  (Loop's /auth/accessToken returns ONLY a new access token,
  //                   it does NOT issue a new refresh token).
  //
  // Storage keys are intentionally shared with tt-loop-login / tt-abo / tt-selector
  // so that login state stays consistent across the customer area. Migration to
  // a sessionStorage/localStorage split is tracked separately.

  function logAuth(event, detail) {
    var payload = detail || {};
    try { console.log('[cockpit-auth]', event, payload); } catch (e) { /* noop */ }
  }

  function isTokenValid(token) {
    if (!token || token === 'undefined') return false;
    try {
      var payload = JSON.parse(atob(token.split('.')[1]));
      return !(payload.exp && payload.exp * 1000 < Date.now());
    } catch (e) { return false; }
  }

  function clearTokens() {
    localStore.removeItem(STORAGE.accessToken);
    localStore.removeItem(STORAGE.refreshToken);
    localStore.removeItem('loop_portal_access_token');
    localStore.removeItem('loop_portal_refresh_token');
    localStore.removeItem('loop_portal_token_expiry');
    localStore.removeItem(STORAGE.merchantView);
  }

  // Leave Loop admin impersonation: drop the session entirely and return to the
  // portal login (neutral landing — the merchant is not a real customer).
  function exitMerchantView() {
    clearTokens();
    state.isMerchantView = false;
    var url = localized(root.getAttribute('data-login-url') || LOGIN_PATH);
    window.location.href = url;
  }

  // Force-refresh the access token by burning the local copy first. Used by
  // the 401-retry path in apiFetch: a server 401 means the local exp check
  // lied (clock drift, server-side revoke, etc.), so we must skip the cache.
  async function refreshAccessToken() {
    localStore.removeItem(STORAGE.accessToken);
    var refresh = localStore.getItem(STORAGE.refreshToken);
    if (!refresh) return null;
    try {
      var res = await fetch(API_BASE + '/auth/accessToken', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: refresh }),
      });
      if (!res.ok) return null;
      var data = await res.json();
      if (data && data.data && data.data.accessToken) {
        localStore.setItem(STORAGE.accessToken, data.data.accessToken);
        return data.data.accessToken;
      }
    } catch (e) { /* network or parse failure */ }
    return null;
  }

  async function getValidToken() {
    var access = localStore.getItem(STORAGE.accessToken);
    if (isTokenValid(access)) return access;
    return await refreshAccessToken();
  }

  // Exchange a session-token URL parameter for an (access, refresh) pair.
  // Returns true on success (and rewrites the URL to strip the token), false
  // on failure (caller should treat as "session expired"). Returns null if
  // no token was present on the URL.
  // Loop's admin "Access customer portal" opens /pages/cockpit?merchantToken=<JWT>.
  // Unlike the Klaviyo sessionToken (which must be exchanged via
  // /auth/refreshToken), the merchantToken IS already a Loop access token —
  // usable directly as the Bearer (verified: GET /storefront/customer returns
  // the impersonated customer). We MUST discard any existing session first,
  // otherwise the cockpit would fall back to whoever is already logged in and
  // show the WRONG customer. There is no refresh token for an impersonation
  // session, so it simply ends (→ login) once the token expires.
  // Returns true if a merchantToken was captured, false otherwise.
  function tryUrlMerchantToken() {
    var params = new URLSearchParams(window.location.search);
    var merchantToken = params.get('merchantToken');
    if (!merchantToken) return false;
    clearTokens();
    localStore.setItem(STORAGE.accessToken, merchantToken);
    localStore.setItem(STORAGE.merchantView, '1');
    state.isMerchantView = true;
    // Strip the token from the URL (history, bookmarks, Referer on outbound links).
    try {
      params.delete('merchantToken');
      var qs = params.toString();
      history.replaceState({}, '', window.location.pathname + (qs ? ('?' + qs) : '') + window.location.hash);
    } catch (e) { /* old browser, leave URL as is */ }
    logAuth('merchant_token_captured');
    return true;
  }

  async function tryUrlSessionTokenExchange() {
    var params = new URLSearchParams(window.location.search);
    var sessionToken = params.get('sessionToken') || params.get('token');
    if (!sessionToken) return null;
    try {
      var res = await fetch(API_BASE + '/auth/refreshToken', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionToken: sessionToken }),
      });
      if (!res.ok) {
        logAuth('url_token_exchange_failed', { status: res.status });
        return false;
      }
      var json = await res.json();
      var pair = json && json.data;
      if (!pair || !pair.accessToken || !pair.refreshToken) {
        logAuth('url_token_exchange_malformed_response');
        return false;
      }
      localStore.setItem(STORAGE.accessToken, pair.accessToken);
      localStore.setItem(STORAGE.refreshToken, pair.refreshToken);
      // A real customer magic-link login supersedes any prior impersonation.
      localStore.removeItem(STORAGE.merchantView);
      state.isMerchantView = false;
      // Drop the token from the URL so it doesn't end up in browser history,
      // bookmarks, the Referer header on outbound links, etc.
      try {
        params.delete('sessionToken');
        params.delete('token');
        var qs = params.toString();
        history.replaceState({}, '', window.location.pathname + (qs ? ('?' + qs) : '') + window.location.hash);
      } catch (e) { /* old browser, leave URL as is */ }
      logAuth('url_token_exchange_ok');
      return true;
    } catch (e) {
      logAuth('url_token_exchange_failed', { reason: 'network' });
      return false;
    }
  }

  function goToLogin(reason) {
    var custom = root.getAttribute('data-login-url');
    var url = localized(custom || LOGIN_PATH);
    if (reason) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'reason=' + encodeURIComponent(reason);
    window.location.href = url;
  }

  // ============================================================
  // API
  // ============================================================

  async function apiFetch(endpoint, opts) {
    var token = await getValidToken();
    if (!token) return null;
    var config = {
      method: (opts && opts.method) || 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
    };
    if (opts && opts.body) config.body = JSON.stringify(opts.body);

    var res = await fetch(API_BASE + endpoint, config);

    // 401 on a call we believed authorised → access token is stale beyond what
    // the local JWT-exp check could detect. Try one rotate via the refresh
    // token and replay the original request. If the rotate also fails, the
    // refresh token is past its 30-day lifetime — clear everything and bounce
    // to login with a reason so the page can show the right banner.
    if (res.status === 401) {
      var rotated = await refreshAccessToken();
      if (!rotated) {
        logAuth('rotate_failed', { reason: 'refresh_expired' });
        clearTokens();
        goToLogin('refresh_expired');
        return null;
      }
      logAuth('rotate_ok');
      config.headers['Authorization'] = 'Bearer ' + rotated;
      res = await fetch(API_BASE + endpoint, config);
      if (res.status === 401) {
        // Refresh succeeded but the new token also gets 401 — Loop is rejecting
        // this customer entirely (revoked, deleted, etc.). Treat as terminal.
        logAuth('rotate_replay_401');
        clearTokens();
        goToLogin('refresh_expired');
        return null;
      }
    }

    var data;
    try { data = await res.json(); } catch (e) { data = null; }
    if (!res.ok) {
      var errMsg = (data && data.message) || ('API ' + res.status);
      console.error('Loop API error:', endpoint, res.status);
      throw new Error(errMsg);
    }
    return data ? (data.data !== undefined ? data.data : data) : null;
  }

  // Edge Function fetch — passes the Loop access token through. The function
  // calls Loop's /customer to verify, then talks to Supabase server-side with
  // the service_role key. Frontend never touches anything but the Loop token.
  async function supabaseFetch(path, opts) {
    var token = await getValidToken();
    if (!token) return null;
    var config = {
      method: (opts && opts.method) || 'GET',
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
    };
    if (opts && opts.body) config.body = JSON.stringify(opts.body);
    var res = await fetch(SUPABASE_FN_BASE + path, config);
    var data;
    try { data = await res.json(); } catch (e) { data = null; }
    if (!res.ok) {
      console.error('Supabase fn error:', path, res.status, data);
      throw new Error((data && data.error) || ('SB ' + res.status));
    }
    return data;
  }

  // Assign this week's dishes after a customer comes back (backoffice, E-44).
  //
  // A subscription that was paused or cancelled still carries the dishes of an
  // OLD menu week — those are not produced in the upcoming order run, so the
  // returning customer would get a box of dishes that no longer exist. The
  // backoffice picks fresh ones from the current week's bundle (AI match against
  // the customer's order history) and swaps them line by line in Loop.
  //
  // Auth carries no secret: we send only the customer's own Loop access token,
  // and the backoffice proves ownership by reading THIS subscription from Loop
  // with that same token. Same trust model as the Supabase Edge Functions above.
  //
  // Deliberately best-effort and time-capped. If the call fails or takes too
  // long we simply move on — the backoffice's cron sweep picks the subscription
  // up minutes later. Aborting here does NOT cancel the server-side run: it
  // keeps going and finishes the swaps.
  var ASSIGN_TIMEOUT_MS = 12000;
  async function assignDishesAfterReturn() {
    var url = (root.getAttribute('data-zuweisung-url') || '').trim();
    if (!url || !state.subscription) return;
    var token = await getValidToken();
    if (!token) return;

    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, ASSIGN_TIMEOUT_MS);
    try {
      var res = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ subscriptionId: state.subscription.id }),
        signal: ctrl.signal,
      });
      if (!res.ok) {
        console.warn('Gerichte-Zuweisung abgelehnt:', res.status);
        return;
      }
      var data = null;
      try { data = await res.json(); } catch (e) { /* Antwort ohne Body */ }
      if (data && data.status) console.info('Gerichte-Zuweisung:', data.status);
    } catch (e) {
      // Abbruch durch den Deckel oder Netzfehler — der Nachlauf übernimmt.
      console.warn('Gerichte-Zuweisung nicht bestätigt:', (e && e.name) || e);
    } finally {
      clearTimeout(timer);
    }
  }

  // ============================================================
  // HELPERS
  // ============================================================

  function esc(s) {
    if (s === null || s === undefined) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(String(s)));
    return d.innerHTML;
  }

  function fmtCHF(n) {
    var v = (parseFloat(n) || 0).toFixed(2);
    return 'CHF\u00A0' + v;
  }

  function fmtDayLong(d) {
    if (!(d instanceof Date) || isNaN(d)) return '—';
    return d.toLocaleDateString(TT_LOCALE, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  }

  function fmtDayShort(d) {
    if (!(d instanceof Date) || isNaN(d)) return '—';
    return d.toLocaleDateString(TT_LOCALE, { weekday: 'short', day: '2-digit', month: '2-digit', year: '2-digit' });
  }

  function fmtDDMMYY(d) {
    if (!(d instanceof Date) || isNaN(d)) return '—';
    return d.toLocaleDateString(TT_LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function fmtISO(d) { return d.toISOString().slice(0, 10); }

  // Bestellschluss (Freitag 11:00) + Lieferung (Mittwoch danach) aus Loop nextBillingDate.
  function getDeadlineAndDelivery(nextBillingDate) {
    if (!nextBillingDate) return { deadline: null, delivery: null };
    var deadline = new Date(nextBillingDate);
    var delivery = new Date(deadline);
    delivery.setDate(delivery.getDate() + 5);
    return { deadline: deadline, delivery: delivery };
  }

  // Resolve the pause-end ("resume") date for a paused subscription. Loop
  // returns it under several names depending on API version / how the pause
  // was created, so we cast a wide net and fall back to the date the user
  // picked at pause time (stashed locally in confirmPause). Returns a Date or
  // null. Shared by render() and the pause-adjust dialog so both agree.
  function getResumeDate(sub) {
    if (!sub) return null;
    var pauseObj = sub.pause || sub.pauseDetails || sub.pauseInfo || {};
    var raw =
      sub.autoResumeDate || sub.pauseResumeDate || sub.resumeDate ||
      sub.pausedTill || sub.pausedUntil || sub.pauseEndDate ||
      sub.resumeAt || sub.resumesAt ||
      pauseObj.autoResumeDate || pauseObj.resumeDate || pauseObj.endDate ||
      null;
    var d = raw ? new Date(raw) : null;
    if (d && isNaN(d.getTime())) d = null;
    if (!d) {
      try {
        var stashed = localStore.getItem('tt_pause_resume_' + sub.id);
        if (stashed) {
          var sd = new Date(stashed);
          if (!isNaN(sd.getTime()) && sd > new Date()) d = sd;
        }
      } catch (e) { /* noop */ }
    }
    return d;
  }

  // Loop's order/paymentFailed webhook surfaces as lastPaymentStatus === 'FAILED'
  // on the subscription (and, defensively, on the most recent order).
  function isPaymentFailed() {
    var sub = state.subscription;
    if (!sub) return false;
    if (sub.lastPaymentStatus === 'FAILED') return true;
    var o = (state.orders || [])[0];
    return !!(o && o.lastPaymentStatus === 'FAILED');
  }

  // Small circle-exclamation used in the payment-failed tile sub-line.
  var PAY_FAIL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>';
  // Small clock used in the card-expiry tile sub-line.
  var CARD_EXP_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  // Warn once the card expires within this many days (drives both the ribbon
  // and the tile sub-line). The displayed day count is dynamic.
  var CARD_EXPIRY_WARN_DAYS = 30;
  // Whole days until the card stops working. A card is valid through the LAST
  // day of its expiry month, so it dies on the 1st of the following month.
  // Returns null when the month/year is missing or unparseable; negative once
  // the card has already expired.
  function cardDaysUntilExpiry(expMonth, expYear) {
    var m = parseInt(expMonth, 10);
    var y = parseInt(expYear, 10);
    if (!(m >= 1 && m <= 12) || !(y > 0)) return null;
    if (y < 100) y += 2000;                 // 2-digit year → 20xx
    var diesOn = new Date(y, m, 1);         // 1st of the month AFTER expiry month
    var now = new Date();
    var todayMid = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.round((diesOn - todayMid) / 86400000);
  }
  // Days until the ACTIVE card expires (null for PayPal / no card / unknown date).
  function activeCardDaysUntilExpiry() {
    var sub = state.subscription;
    if (!sub) return null;
    var activeId = sub.customerPaymentMethodId || sub.paymentMethodId;
    var pms = state.paymentMethods || [];
    var primary = pms.find(function (pm) { return pm.id === activeId; }) || pms[0];
    if (!primary || primary.type === 'CustomerPaypalBillingAgreement') return null;
    var card = primary.card || {};
    return cardDaysUntilExpiry(card.expiryMonth || primary.expiryMonth, card.expiryYear || primary.expiryYear);
  }
  // Localized "expires in N days" text for a key prefix ('card_expiry_ribbon' or
  // 'card_expiry_tile'), with singular / already-expired variants.
  function cardExpiryMsg(prefix, days) {
    if (days <= 0) return T.cockpit[prefix + '_expired'];
    if (days === 1) return T.cockpit[prefix + '_day_one'];
    return T.t('cockpit.' + prefix + '_days', { count: days });
  }

  // The next POSSIBLE order cutoff: the upcoming Friday 11:00 (order deadline).
  // Used as a fallback for the next-delivery date when Loop hasn't (re)computed
  // the subscription's nextBillingDate yet — most notably right after a resume,
  // where GET /subscription can briefly still report the paused (null) value,
  // which would otherwise leave the hero showing "—".
  function nextPossibleBilling() {
    var now = new Date();
    var d = new Date(now);
    var diff = (5 - d.getDay() + 7) % 7; // days until Friday (getDay 5)
    if (diff === 0 && now.getHours() >= 11) diff = 7; // Friday past cutoff → next
    d.setDate(d.getDate() + diff);
    d.setHours(11, 0, 0, 0);
    return d;
  }

  // The order date to send to Loop's /reschedule so the next order fires on the
  // soonest anchor Friday. Two Loop behaviours shape this:
  //   1. /reschedule rejects any billing datetime < 24h out ("at least 24 hours
  //      from now").
  //   2. Loop keeps only the DATE we send and snaps the TIME to the billing
  //      anchor (~11:05). Verified: sending Fri 12:09 → stored Fri 11:05.
  // So we send a datetime ON the upcoming anchor Friday that clears the 24h
  // check (a later time the same day if 11:00 is already too close). Only when
  // the whole Friday is inside the 24h window do we move to the next Friday —
  // the delivery (= billing + 5 days) then stays on its Wednesday either way.
  function soonestReschedulableBilling() {
    var minSend = Date.now() + 24 * 60 * 60 * 1000 + 30 * 60 * 1000; // 24h + 30min margin
    var d = nextPossibleBilling(); // upcoming anchor Friday, 11:00 local
    if (d.getTime() < minSend) {
      var endOfFriday = new Date(d); endOfFriday.setHours(23, 59, 0, 0);
      if (minSend <= endOfFriday.getTime()) {
        d = new Date(minSend); // same Friday, later time → clears 24h; Loop snaps to the anchor
      } else {
        d.setDate(d.getDate() + 7); // entire Friday within 24h → next anchor Friday
      }
    }
    return d;
  }

  function nextWednesdayAfter(date) {
    var d = new Date(date);
    var day = d.getDay();
    var diff = (3 - day + 7) % 7;
    if (diff === 0) diff = 7;
    d.setDate(d.getDate() + diff);
    return d;
  }

  function showView(view) {
    elLoading.style.display = view === 'loading' ? '' : 'none';
    elContent.style.display = view === 'content' ? '' : 'none';
    elError.style.display = view === 'error' ? '' : 'none';
  }

  // ============================================================
  // STREAK BANNER (5-week welcome program — analog Selector/Abo)
  // ============================================================

  function ttDecodeHtml(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.innerHTML = String(s);
    return d.textContent || '';
  }

  var STREAK_STEPS = [
    { week: 1, kind: 'discount', big: '20%',           title: T.streak && T.streak.welcome_discount },
    { week: 2, kind: 'discount', big: '10%',           title: T.streak && T.streak.loyalty_bonus },
    { week: 3, kind: 'gift',     big: T.streak && T.streak.gift, title: T.streak && T.streak.surprise },
    { week: 4, kind: 'discount', big: '5%',            title: T.streak && T.streak.loyalty_bonus },
    { week: 5, kind: 'gift',     big: T.streak && T.streak.gift, title: T.streak && T.streak.surprise }
  ];

  function getStreakWeek() {
    // QA override via URL: ?week=1..5 forces a week, ?week=0/off hides.
    try {
      var override = new URLSearchParams(window.location.search).get('week');
      if (override !== null) {
        if (override === '0' || override === 'off' || override === 'none') return null;
        var n = parseInt(override, 10);
        if (!isNaN(n) && n >= 1 && n <= 5) return n;
      }
    } catch (e) { /* noop */ }

    // Week = processed orders + 1. Past week 5 the welcome program is over
    // and the banner disappears (unlike the selector, the cockpit is the
    // customer's long-term home — a forever-"Woche 5" would mislead).
    var sub = state.subscription || {};
    var cust = state.customer || {};
    var candidates = [
      (state.orders || []).length || null,
      sub.streakWeek, sub.welcomeWeek,
      sub.processedOrderCount, sub.successfulOrderCount, sub.orderCount,
      cust.lifetimeOrderCount, cust.processedOrderCount, cust.orderCount
    ];
    for (var i = 0; i < candidates.length; i++) {
      var v = candidates[i];
      if (typeof v === 'number' && v >= 0) {
        var wk = v + 1;
        return wk > 5 ? null : Math.max(1, wk);
      }
    }
    return null;
  }

  function renderStreak() {
    var el = document.getElementById('tt-cp-streak');
    if (!el) return;
    var sub = state.subscription;
    var week = (sub && sub.status !== 'CANCELLED') ? getStreakWeek() : null;
    if (week == null || !T.streak) { el.hidden = true; el.innerHTML = ''; return; }

    var iconGift  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
    var iconPct   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
    var iconCheck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>';
    var iconBadgePct = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
    var iconChev = '<svg class="tt-sel-streak__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="6 9 12 15 18 9"/></svg>';

    var defaultOpen = state.streakOpen === true;
    var html = '<details class="tt-sel-streak__inner"' + (defaultOpen ? ' open' : '') + '>';
    html += '<summary class="tt-sel-streak__summary">';
    html += '<span class="tt-sel-streak__badge" aria-hidden="true">' + iconBadgePct + '</span>';
    html += '<span class="tt-sel-streak__head-text">';
    html += '<span class="tt-sel-streak__head-title">' + esc(ttDecodeHtml(T.streak.banner_title || T.streak.program)) + '</span>';
    if (T.streak.banner_subtitle) {
      html += '<span class="tt-sel-streak__head-sub">' + esc(ttDecodeHtml(T.streak.banner_subtitle)) + '</span>';
    }
    html += '</span>';
    html += iconChev;
    html += '</summary>';
    html += '<ol class="tt-sel-streak__track" aria-label="' + esc(ttDecodeHtml(T.streak.banner_title || T.streak.program)) + '">';
    STREAK_STEPS.forEach(function (s, i) {
      var st = s.week < week ? 'done' : (s.week === week ? 'current' : 'upcoming');
      var icon = st === 'done' ? iconCheck : (s.kind === 'gift' ? iconGift : iconPct);
      html += '<li class="tt-sel-streak__node is-' + st + '">';
      if (i > 0) html += '<span class="tt-sel-streak__line" aria-hidden="true"></span>';
      html += '<span class="tt-sel-streak__dot">' + icon + '</span>';
      html += '<span class="tt-sel-streak__label">';
      html += '<span class="tt-sel-streak__label-week">' + esc(T.t('streak.week_n', {n: s.week})) + '</span>';
      html += '<span class="tt-sel-streak__label-big">' + esc(s.kind === 'gift' ? T.streak.gift : s.big) + '</span>';
      html += '</span></li>';
    });
    html += '</ol></details>';
    el.innerHTML = html;
    el.hidden = false;
    var details = el.querySelector('details');
    if (details) {
      details.addEventListener('toggle', function () { state.streakOpen = details.open; });
    }
  }

  // ============================================================
  // RENDER
  // ============================================================

  function render() {
    var sub = state.subscription;
    var cust = state.customer;
    var status = sub ? sub.status : null;
    var isPaused = status === 'PAUSED';
    var isCancelled = status === 'CANCELLED';

    document.body.classList.toggle('tt-cp-cancelled', isCancelled);
    document.body.classList.toggle('tt-cp-paused', isPaused);

    // Merchant-impersonation banner (entered via Loop admin "Access customer
    // portal"). Names the customer whose portal is being viewed.
    // Das neue Tom Tasty (E-65): nicht in der Händler-Ansicht — dort würde der
    // Knopf das Team als Kundin im neuen Shop anmelden.
    var neuRibbon = document.getElementById('neu-ribbon');
    if (neuRibbon) neuRibbon.hidden = !!state.isMerchantView;
    var neuUmzug = document.getElementById('neu-umzug');
    if (neuUmzug) neuUmzug.hidden = !!state.isMerchantView || neuUmzugVerschoben();

    var mvBanner = document.getElementById('merchant-view-banner');
    if (mvBanner) {
      if (state.isMerchantView) {
        var nm = cust ? ((cust.firstName || '') + ' ' + (cust.lastName || '')).trim() : '';
        var em = cust ? (cust.email || '') : '';
        var label = nm || em || '';
        if (nm && em && em !== nm) label = nm + ' · ' + em;
        var nameEl = document.getElementById('merchant-view-name');
        if (nameEl) nameEl.textContent = label;
        mvBanner.hidden = false;
      } else {
        mvBanner.hidden = true;
      }
    }

    var hero = document.getElementById('delivery-hero');
    hero.classList.toggle('paused', isPaused);
    hero.classList.toggle('cancelled', isCancelled);

    renderStreak();

    if (!sub) {
      renderNoSub();
      return;
    }

    var lines = sub.lines || [];
    var mealCount = 0;
    lines.forEach(function (l) { mealCount += (l.quantity || 1); });

    // Totals
    // Loop legitimately returns totalLineItemDiscountedPrice: 0 for a 100%
    // discount, so `||` (which treats 0 as falsy) would wrongly fall through
    // to the undiscounted totalLineItemPrice. Check for null/undefined
    // explicitly instead.
    var hasSubLineTotal = sub.totalLineItemDiscountedPrice != null || sub.totalLineItemPrice != null;
    var lineTotal = (sub.totalLineItemDiscountedPrice != null)
      ? parseFloat(sub.totalLineItemDiscountedPrice)
      : parseFloat(sub.totalLineItemPrice || 0);
    var deliveryPrice = parseFloat(sub.deliveryPrice || 0);
    if (!hasSubLineTotal && lines.length) {
      lineTotal = 0;
      lines.forEach(function (l) { lineTotal += (parseFloat(l.price) || 0) * (l.quantity || 1); });
    }
    var weeklyTotal = lineTotal + deliveryPrice;

    var schedule = getDeadlineAndDelivery(sub.nextBillingDate);

    // The "coming week" = the earliest still-future scheduled order, INCLUDING
    // a skipped one. The hero AND the dish list both anchor on this single
    // order so they always agree (anchoring the hero and the dishes on
    // different orders is what previously made the header show one week while
    // the dishes showed another). When this order is skipped the hero shows it
    // as "Übersprungen" and offers a restore; otherwise it offers a skip.
    var comingOrder = null;
    (state.scheduledOrders || [])
      .slice()
      .sort(function (a, b) {
        return new Date(a.billingDate || a.nextBillingDate) - new Date(b.billingDate || b.nextBillingDate);
      })
      .some(function (o) {
        var d = new Date(o.billingDate || o.nextBillingDate);
        if (!isNaN(d.getTime()) && d >= new Date(Date.now() - 36e5)) { comingOrder = o; return true; }
        return false;
      });
    state.comingOrder = comingOrder;
    var comingSkipped = !!(comingOrder && comingOrder.status === 'SKIPPED');

    if (isPaused) {
      // Only the pause-end ("until") date is shown for paused subs. The next
      // delivery date is intentionally NOT displayed: while paused there is no
      // committed next order, so any computed date would be a guess that
      // confuses customers.
      var resumeD = getResumeDate(sub);
      var pauseUntilEl = document.getElementById('paused-until-date');
      pauseUntilEl.textContent = resumeD ? 'bis ' + fmtDayLong(resumeD) : T.cockpit.paused_label;
      if (resumeD) pauseUntilEl.setAttribute('datetime', fmtISO(resumeD));
    } else if (isCancelled) {
      // "Beendet seit" = cancelledAt
      var endDate = sub.cancelledAt || sub.cancelledOn || sub.endedAt || sub.updatedAt;
      var endD = endDate ? new Date(endDate) : null;
      // "Letzte Lieferung" = jüngster PROCESSED order in der Historie
      var lastOrder = (state.orders || []).find(function (o) {
        return o.status === 'PROCESSED' || o.fulfillmentStatus === 'FULFILLED';
      });
      var lastDel = null;
      if (lastOrder) {
        var lastSrc = lastOrder.shopifyCreatedAt || lastOrder.billingDate || lastOrder.createdAt;
        if (lastSrc) {
          // Delivery = billing Friday + 5 Tage (Mittwoch)
          lastDel = getDeadlineAndDelivery(lastOrder.billingDate || lastSrc).delivery || new Date(lastSrc);
        }
      }
      if (!lastDel && endD) lastDel = endD;
      document.getElementById('cancelled-date').textContent = endD ? T.t('cockpit.cancelled_since_label', {date: fmtDayLong(endD)}) : T.cockpit.cancelled_label;
      if (endD) document.getElementById('cancelled-date').setAttribute('datetime', fmtISO(endD));
      document.getElementById('cancelled-last-date').textContent = lastDel ? fmtDayLong(lastDel) : '—';
    } else {
      // Anchor the hero (and, via `schedule`, the dish list below) on the
      // soonest upcoming order so both always show the same week. When that
      // order is skipped, the hero shows "· Übersprungen" + a restore button;
      // otherwise the next-possible delivery + a skip button.
      if (comingOrder) {
        schedule = getDeadlineAndDelivery(comingOrder.billingDate || comingOrder.nextBillingDate);
      }
      // No committed order yet (e.g. right after a resume, while Loop recomputes
      // the schedule) → fall back to the next POSSIBLE order so the hero always
      // shows a delivery date instead of an empty "—".
      if (!schedule.delivery) {
        schedule = getDeadlineAndDelivery(nextPossibleBilling());
      }
      // Roll the deadline forward in 7-day steps if Friday 11:00 is more than
      // 1h past (Loop's nextBillingDate can be stale right after a deadline).
      if (schedule.deadline) {
        var graceMs = 60 * 60 * 1000;
        for (var rollGuard = 0; rollGuard < 52; rollGuard++) {
          var d11 = new Date(schedule.deadline);
          d11.setHours(11, 0, 0, 0);
          if ((Date.now() - d11) <= graceMs) break;
          schedule.deadline.setDate(schedule.deadline.getDate() + 7);
          schedule.delivery.setDate(schedule.delivery.getDate() + 7);
        }
      }
      var skipBtn = document.getElementById('btn-skip-next');
      var dateStr = schedule.delivery ? fmtDayLong(schedule.delivery) : '—';
      document.getElementById('delivery-date').textContent = comingSkipped ? (dateStr + ' · ' + T.cockpit.status_skipped) : dateStr;
      if (schedule.delivery) document.getElementById('delivery-date').setAttribute('datetime', fmtISO(schedule.delivery));
      document.getElementById('delivery-deadline').textContent = schedule.deadline ? fmtDayShort(schedule.deadline) + ' · 11:00' : '—';
      updateDeadlineBadge(schedule.deadline);
      if (skipBtn) {
        if (comingSkipped) { skipBtn.textContent = T.cockpit.restore_delivery; skipBtn.dataset.mode = 'restore'; }
        else { skipBtn.textContent = T.cockpit.manage_skip_next; skipBtn.dataset.mode = 'skip'; }
      }
    }

    // Dishes — while paused we suppress the delivery date in the title since
    // the next delivery is not yet committed (see paused empty-state).
    renderDishes(lines, isPaused ? null : schedule.delivery, mealCount);

    // Price summary
    renderPriceSummary(sub, lines, lineTotal, deliveryPrice, weeklyTotal);

    // Scheduled deliveries
    renderPlannedDeliveries();

    // Address
    renderAddress(sub.shippingAddress || {});

    // Payment method (primary)
    renderPrimaryPaymentMethod();

    // Payment-failed ribbon (between site nav and page title)
    var pfRibbon = document.getElementById('payment-failed-ribbon');
    if (pfRibbon) pfRibbon.hidden = !isPaymentFailed();

    // Card-expiry ribbon — mutually exclusive with the payment-failed ribbon
    // (a failed payment is the more urgent message). The title carries the
    // dynamic day count.
    var ceRibbon = document.getElementById('card-expiry-ribbon');
    if (ceRibbon) {
      var ceDays = isPaymentFailed() ? null : activeCardDaysUntilExpiry();
      var ceShow = ceDays != null && ceDays <= CARD_EXPIRY_WARN_DAYS;
      ceRibbon.hidden = !ceShow;
      if (ceShow) {
        var ceTitle = document.getElementById('card-expiry-ribbon-title');
        if (ceTitle) ceTitle.textContent = cardExpiryMsg('card_expiry_ribbon', ceDays);
      }
    }

    // Coupons
    renderCoupons(sub.discounts || sub.appliedDiscounts || []);

    // Notifications (channel preference)
    renderNotifications();

    // Order history
    renderOrderHistory();
  }

  function renderNoSub() {
    document.getElementById('delivery-date').textContent = T.cockpit.no_subscription;
    document.getElementById('delivery-deadline').textContent = '';
    document.getElementById('deadline-badge').style.display = 'none';
    var actions = document.querySelector('.delivery-hero .active-only .delivery-actions');
    if (actions) actions.innerHTML = T.cockpit.no_subscription_cta;

    document.getElementById('dish-list').innerHTML = '';
    document.getElementById('planned-list-near').innerHTML = '';
    document.getElementById('order-history-list').innerHTML = '<div class="empty-state"><strong>' + esc(T.cockpit.no_orders) + '</strong></div>';
    document.getElementById('order-history-footer').style.display = 'none';
  }

  function updateDeadlineBadge(deadline) {
    var badge = document.getElementById('deadline-badge');
    if (!badge || !deadline) { if (badge) badge.style.display = 'none'; return; }
    badge.style.display = '';
    // Deadline is Friday 11:00
    var target = new Date(deadline);
    target.setHours(11, 0, 0, 0);
    var ms = target - new Date();
    if (ms <= 0) { badge.textContent = T.cockpit.deadline_passed; badge.classList.add('urgent'); return; }
    var days = Math.floor(ms / 86400000);
    var hours = Math.floor((ms % 86400000) / 3600000);
    var mins = Math.floor((ms % 3600000) / 60000);
    badge.classList.remove('warn', 'urgent');
    var label;
    if (days >= 2) { label = T.t('cockpit.still_days_label', {count: days}); }
    else if (days === 1) { label = T.t('cockpit.still_1_day_hours_short', {hours: hours}); badge.classList.add('warn'); }
    else if (hours >= 1) { label = T.t('cockpit.still_hours_minutes', {hours: hours, minutes: mins}); badge.classList.add('urgent'); }
    else { label = T.t('cockpit.still_minutes_only', {minutes: mins}); badge.classList.add('urgent'); }
    badge.textContent = label;
  }

  function renderDishes(lines, deliveryDate, mealCount) {
    var list = document.getElementById('dish-list');
    var countPill = document.getElementById('dishes-count');
    var title = document.getElementById('dishes-title');
    var pager = document.getElementById('dish-pager');

    if (deliveryDate) {
      title.textContent = T.t('cockpit.delivery_from_short', {date: deliveryDate.toLocaleDateString(TT_LOCALE, { day: 'numeric', month: 'long' })});
    } else {
      title.textContent = T.cockpit.delivery_label_only;
    }
    countPill.textContent = T.t('cockpit.dishes_count_label', {count: mealCount});
    countPill.setAttribute('aria-label', T.t('cockpit.dishes_count_label', {count: mealCount}));

    if (!lines.length) { list.innerHTML = ''; pager.hidden = true; return; }

    var total = lines.length;
    var html = '';
    var slice = lines;
    if (total > DISH_PAGE_SIZE) {
      var totalPages = Math.ceil(total / DISH_PAGE_SIZE);
      state.dishPage = Math.min(Math.max(1, state.dishPage), totalPages);
      var start = (state.dishPage - 1) * DISH_PAGE_SIZE;
      slice = lines.slice(start, start + DISH_PAGE_SIZE);
    }

    slice.forEach(function (line) {
      var qty = line.quantity || 1;
      var imgUrl = line.image ? (line.image.url || line.image) : null;
      var name = dishDisplayName(line, T.cockpit.dish_fallback || 'Gericht');
      // No per-item price — only the total price is shown in the summary.
      html += '<div class="dish" role="listitem">';
      html += '<div class="dish-img">';
      if (imgUrl) html += '<img src="' + esc(imgUrl) + '" alt="" loading="lazy">';
      else html += '<span aria-hidden="true">🍽️</span>';
      html += '<span class="dish-qty">' + qty + '×</span>';
      html += '</div>';
      html += '<div><div class="dish-name">' + esc(name) + '</div></div>';
      html += '</div>';
    });
    list.innerHTML = html;

    if (total > DISH_PAGE_SIZE) {
      var totalPages2 = Math.ceil(total / DISH_PAGE_SIZE);
      pager.hidden = false;
      pager.innerHTML = pagerBtns(totalPages2, state.dishPage, 'dpage');
    } else {
      pager.hidden = true;
      pager.innerHTML = '';
    }
  }

  function renderPriceSummary(sub, lines, lineTotal, deliveryPrice, weeklyTotal) {
    var el = document.getElementById('price-summary');
    var originalTotal = 0;
    lines.forEach(function (l) { originalTotal += (parseFloat(l.price) || 0) * (l.quantity || 1); });
    // Pre-discount all-in (line items + shipping). The gap to weeklyTotal is
    // the total saving — shown only as a struck-through "was" price, never
    // itemised into individual discount lines.
    var originalAllIn = originalTotal + deliveryPrice;
    var hasDiscount = (originalAllIn - weeklyTotal) > 0.01;

    var html = '';

    // Shipping stays as its own line — it's a service note, not a discount.
    if (deliveryPrice > 0) {
      html += '<div class="summary-row"><span class="lbl">' + esc(T.cockpit.shipping) + '</span><span class="val">' + fmtCHF(deliveryPrice) + '</span></div>';
    } else {
      html += '<div class="summary-row free"><span class="lbl">' + esc(T.cockpit.shipping) + '</span><span class="val">' + esc(T.cockpit.shipping_free_short) + '</span></div>';
    }

    // "Dein Preis" — struck-through original + the price actually paid.
    html += '<div class="summary-row total"><span class="lbl">' + esc(T.cockpit.your_price_label) + '</span><span class="val">';
    if (hasDiscount) html += '<s class="price-was">' + fmtCHF(originalAllIn) + '</s> ';
    html += '<span class="price-now">' + fmtCHF(weeklyTotal) + '</span></span></div>';

    el.innerHTML = html;
  }

  function renderPlannedDeliveries() {
    var near = document.getElementById('planned-list-near');
    var extra = document.getElementById('delivery-extra');
    var toggleRow = document.getElementById('planned-toggle-row');
    var toggleLink = document.getElementById('toggle-deliveries');

    var threeWeeksFromNow = new Date(); threeWeeksFromNow.setDate(threeWeeksFromNow.getDate() + 21);
    var twoMonthsFromNow = new Date(); twoMonthsFromNow.setMonth(twoMonthsFromNow.getMonth() + 2);

    var nearOrders = state.scheduledOrders.filter(function (o) {
      var d = new Date(o.billingDate || o.nextBillingDate);
      return d <= threeWeeksFromNow;
    });
    var extendedOrders = state.scheduledOrders.filter(function (o) {
      var d = new Date(o.billingDate || o.nextBillingDate);
      return d <= twoMonthsFromNow && d > threeWeeksFromNow;
    });

    near.innerHTML = nearOrders.map(scheduledRow).join('');
    extra.innerHTML = extendedOrders.map(scheduledRow).join('');

    if (extendedOrders.length) {
      toggleRow.style.display = '';
      toggleLink.setAttribute('aria-expanded', String(state.deliveriesExpanded));
      extra.classList.toggle('open', state.deliveriesExpanded);
      extra.setAttribute('aria-hidden', String(!state.deliveriesExpanded));
      toggleLink.textContent = state.deliveriesExpanded ? T.cockpit.planned_show_less_link : T.cockpit.planned_show_more;
    } else {
      toggleRow.style.display = 'none';
    }
  }

  function scheduledRow(o) {
    var billingDate = o.billingDate || o.nextBillingDate;
    var sched = getDeadlineAndDelivery(billingDate);
    var delivery = sched.delivery || (billingDate ? new Date(billingDate) : null);
    var isSkipped = o.status === 'SKIPPED';
    var dateStr = delivery ? fmtDayLong(delivery) : '—';
    var iso = delivery ? fmtISO(delivery) : '';

    var h = '';
    h += '<div class="delivery-row" data-order-id="' + esc(o.id) + '">';
    h += '<div class="delivery-row-left">';
    h += '<span class="dot ' + (isSkipped ? 'dot-muted' : 'dot-green') + '" aria-hidden="true"></span>';
    h += '<span class="delivery-row-date ' + (isSkipped ? 'skipped' : '') + '">';
    h += '<time' + (iso ? ' datetime="' + iso + '"' : '') + '>' + esc(dateStr) + '</time>';
    h += '</span>';
    h += '</div>';
    h += '<div class="delivery-row-actions">';
    if (isSkipped) {
      h += '<span class="status-pill status-amber" aria-label="' + esc(T.cockpit.status_skipped_aria) + '">' + esc(T.cockpit.status_skipped) + '</span>';
      h += '<button type="button" class="link-restore" data-unskip="' + esc(o.id) + '">';
      h += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';
      h += esc(T.cockpit.restore) + '</button>';
    } else {
      h += '<span class="status-pill status-green" aria-label="' + esc(T.cockpit.status_planned_aria) + '">' + esc(T.cockpit.status_planned) + '</span>';
      h += '<button type="button" class="link-action" data-skip="' + esc(o.id) + '" data-date="' + esc(dateStr) + '">' + esc(T.cockpit.skip_action) + '</button>';
    }
    h += '</div>';
    h += '</div>';
    return h;
  }

  function renderAddress(addr) {
    var el = document.getElementById('address-display');
    if (!addr || (!addr.address1 && !addr.firstName)) {
      el.innerHTML = '<span style="color:var(--muted)">' + esc(T.cockpit.no_address) + '</span>';
      return;
    }
    var h = '';
    if (addr.firstName || addr.lastName) h += esc((addr.firstName || '') + ' ' + (addr.lastName || '')) + '<br>';
    if (addr.address1) h += esc(addr.address1) + '<br>';
    if (addr.address2) h += esc(addr.address2) + '<br>';
    if (addr.zip || addr.city) h += esc((addr.zip || '') + ' ' + (addr.city || '')) + '<br>';
    if (addr.phone) h += '<a href="tel:' + esc(addr.phone.replace(/\s/g, '')) + '" style="color:inherit;text-decoration:none;">' + esc(addr.phone) + '</a>';
    el.innerHTML = h;
  }

  function brandKey(brand) {
    var b = String(brand || '').toLowerCase();
    if (b.indexOf('master') >= 0 || b === 'mc') return 'mc';
    if (b.indexOf('visa') >= 0) return 'visa';
    if (b.indexOf('amex') >= 0 || b.indexOf('american') >= 0) return 'amex';
    if (b.indexOf('paypal') >= 0) return 'paypal';
    return 'other';
  }
  function brandLabel(k) {
    return { mc: 'MC', visa: 'VISA', amex: 'AMEX', paypal: 'PP', other: 'CARD' }[k] || 'CARD';
  }
  function brandName(k) {
    return { mc: 'Mastercard', visa: 'Visa', amex: 'American Express', paypal: 'PayPal', other: T.cockpit.card_label }[k] || T.cockpit.card_label;
  }

  function renderPrimaryPaymentMethod() {
    var sub = state.subscription;
    if (!sub) return;
    // Loop's subscription API returns the active payment method as
    // customerPaymentMethodId (storefront 2023-10). The legacy
    // "paymentMethodId" alias is undefined, so it must be read here.
    var activeId = sub.customerPaymentMethodId || sub.paymentMethodId;
    var pms = state.paymentMethods || [];
    var primary = pms.find(function (pm) { return pm.id === activeId; }) || pms[0];

    var nameEl = document.getElementById('payment-name');
    var subEl = document.getElementById('payment-sub');
    var iconEl = document.getElementById('payment-brand-icon');

    // Failed last payment → red ring on the tile + error sub-line (replaces
    // the "valid until" line). Webhook: order/paymentFailed.
    var failed = isPaymentFailed();
    var cardEl = document.getElementById('payment-card');
    if (cardEl) cardEl.classList.toggle('payment-card--failed', failed);
    function applyFailedSub() {
      subEl.innerHTML = '<span class="payment-sub--error">' + PAY_FAIL_ICON
        + '<span>' + esc(T.cockpit.payment_failed_tile) + '</span></span>';
    }

    if (!primary) {
      nameEl.innerHTML = '<span style="color:var(--muted)">' + esc(T.cockpit.no_card) + '</span>';
      subEl.textContent = T.cockpit.add_payment_method;
      iconEl.textContent = '—';
      if (failed) applyFailedSub();
      return;
    }
    var isPaypal = primary.type === 'CustomerPaypalBillingAgreement';
    var card = primary.card || {};
    var bk = isPaypal ? 'paypal' : brandKey(card.brand || primary.brand);
    var digits = card.lastDigits || card.last4 || primary.lastDigits || '';
    var expMonth = card.expiryMonth || primary.expiryMonth;
    var expYear = card.expiryYear || primary.expiryYear;

    iconEl.textContent = brandLabel(bk);
    if (isPaypal) {
      nameEl.innerHTML = 'PayPal';
      subEl.textContent = (primary.payPal && primary.payPal.email) ? primary.payPal.email : '';
    } else {
      nameEl.innerHTML = esc(brandName(bk)) + (digits ? ' ···· <span translate="no">' + esc(digits) + '</span>' : '');
      var expDays = cardDaysUntilExpiry(expMonth, expYear);
      if (expDays != null && expDays <= CARD_EXPIRY_WARN_DAYS) {
        // Expiring soon → orange warning sub-line with the dynamic day count,
        // in place of the usual "valid until MM/YY".
        subEl.innerHTML = '<span class="payment-sub--warn">' + CARD_EXP_ICON
          + '<span>' + esc(cardExpiryMsg('card_expiry_tile', expDays)) + '</span></span>';
      } else {
        subEl.textContent = (expMonth && expYear) ? T.t('cockpit.valid_until_full', {month: String(expMonth).padStart(2, '0'), year: String(expYear).slice(-2)}) : '';
      }
    }
    if (failed) applyFailedSub();
  }

  function renderCoupons(discounts) {
    var list = document.getElementById('coupon-list');
    var divider = document.getElementById('coupon-divider');
    // LPBNDL codes are automatic quantity-tier discounts managed by Loop —
    // they're not customer-applied coupons and shouldn't appear in the
    // user-facing voucher list (and shouldn't expose a remove button).
    var visible = discounts.filter(function (d) {
      var code = (d && (d.code || d.title)) || '';
      return code.toUpperCase().indexOf('LPBNDL') !== 0;
    });
    if (!visible.length) { list.innerHTML = ''; divider.hidden = true; return; }
    divider.hidden = false;
    var h = '';
    visible.forEach(function (d) {
      var code = d.code || d.title || '';
      var label = T.cockpit.discount_campaign;
      var pct = d.value && d.value.percentage;
      h += '<div class="coupon-row" data-coupon-id="' + esc(d.shopifyId || d.id || code) + '" data-coupon-code="' + esc(code) + '" data-coupon-label="' + esc(label) + '">';
      h += '<div class="coupon-info">';
      h += '<div class="coupon-name-text">' + esc(label);
      if (pct) h += ' <span style="color:var(--muted); font-weight:500;">· –' + esc(pct) + '%</span>';
      h += '</div>';
      h += '<button type="button" class="code-copy" data-code="' + esc(code) + '" aria-label="' + esc(T.t('cockpit.code_copy_aria', {code: code})) + '" style="margin-top:0.4rem;">';
      h += '<code translate="no">' + esc(code) + '</code>';
      h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="14" height="14" x="8" y="8" rx="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>';
      h += '</button>';
      h += '</div>';
      h += '<button type="button" class="coupon-remove" aria-label="' + esc(T.t('cockpit.coupon_remove_aria', {label: label})) + '" data-remove-coupon="' + esc(code) + '">';
      h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
      h += '</button>';
      h += '</div>';
    });
    list.innerHTML = h;
  }

  function renderNotifications() {
    var channel = (state.profile && state.profile.marketing_channel)
      ? state.profile.marketing_channel
      : (localStore.getItem('tt_marketing_channel') || 'whatsapp');

    document.querySelectorAll('.channel-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.channel === channel));
    });

    var fields = document.getElementById('whatsapp-fields');
    var needsPhone = channel === 'whatsapp' || channel === 'both';
    if (needsPhone) {
      fields.style.maxHeight = '300px';
      fields.style.opacity = '1';
      fields.hidden = false;
    } else {
      fields.style.maxHeight = '0';
      fields.style.opacity = '0';
      fields.hidden = true;
    }
    // seed phone
    var phoneInput = document.getElementById('whatsapp-number');
    var addr = state.subscription && state.subscription.shippingAddress;
    if (phoneInput && !phoneInput.value) {
      phoneInput.value = (addr && addr.phone) || '';
    }
  }

  // After the dish selector saves it redirects to ?from=dishes. Once the
  // content is visible AND reviews have loaded, scroll to the past-deliveries
  // card so the customer lands on the open-reviews hint — but only if there
  // is actually something left to rate. Runs at most once; the flag is
  // stripped from the URL so a later manual reload doesn't re-scroll.
  function tryScrollToReviewsAfterSave() {
    if (state._reviewScrollHandled || !state._reviewsLoaded) return;
    var content = document.getElementById('tt-cp-content');
    if (!content || content.style.display === 'none') return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('from') !== 'dishes') return;
    state._reviewScrollHandled = true;
    params.delete('from');
    var qs = params.toString();
    try {
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}
    if (!findNextUnrated()) return;
    var target = document.getElementById('order-history-card');
    if (target) {
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  // Loop liefert direkt nach einem Bundle-Update teils noch den alten Stand
  // (eventual consistency). Kommt der Kunde frisch vom Gerichte-Speichern,
  // holen wir das Abo nach kurzer Wartezeit erneut und rendern nur bei
  // tatsächlicher Abweichung neu — sonst zeigt das Cockpit die alte
  // Gerichtzahl und der Kunde hält sein Speichern für verloren
  // (Kundin 541820894, 11.06.).
  function scheduleStaleDishRecheck() {
    if (!state.subscription || !state.subscription.id) return;
    function linesSig(sub) {
      return JSON.stringify((sub.lines || []).map(function (l) {
        return [String(l.variantShopifyId || l.id || ''), l.quantity || 1];
      }).sort());
    }
    var renderedSig = linesSig(state.subscription);
    setTimeout(function () {
      apiFetch('/subscription/' + state.subscription.id).then(function (fresh) {
        if (!fresh || !fresh.lines) return;
        if (linesSig(fresh) !== renderedSig) {
          state.subscription = fresh;
          render();
        }
      }).catch(function () { /* non-fatal */ });
    }, 4000);
  }

  // Clickable "du hast noch Bewertungen offen" notice shown at the top of the
  // past-deliveries list. Carries data-rate-* so the existing delegated
  // [data-rate-product] handler opens the review modal — one click into the
  // rating flow, starting at the first unrated dish.
  function reviewHintHtml(pending) {
    if (!pending) return '';
    var prog = reviewProgress();
    var open = Math.max(1, prog.total - prog.done);
    var title = open === 1
      ? (T.cockpit.review_hint_title_one || T.t('cockpit.review_hint_title_other', { count: 1 }))
      : T.t('cockpit.review_hint_title_other', { count: open });
    var pid = lineProductId(pending.line);
    return '<button type="button" class="review-hint" data-rate-order="' + esc(pending.order.id) + '" data-rate-product="' + esc(pid) + '">'
      + '<span class="review-hint__icon" aria-hidden="true">★</span>'
      + '<span class="review-hint__body">'
      + '<span class="review-hint__title">' + esc(title) + '</span>'
      + '<span class="review-hint__text">' + esc(T.cockpit.review_hint_text || '')
      + ' <span class="review-hint__cta">' + esc(T.cockpit.review_rate_cta) + ' →</span>'
      + '</span>'
      + '</span>'
      + '</button>';
  }

  function renderOrderHistory() {
    var list = document.getElementById('order-history-list');
    var footer = document.getElementById('order-history-footer');
    var orders = state.orders || [];
    if (!orders.length) {
      list.innerHTML = '<div class="empty-state"><strong>' + esc(T.cockpit.no_orders) + '</strong></div>';
      footer.style.display = 'none';
      return;
    }
    footer.style.display = '';

    // Open-reviews hint: once /my-reviews has loaded, surface a clickable
    // notice if any rateable dish is still unrated. The delivery itself stays
    // collapsed — every row closed keeps the list scannable; the hint is the
    // one-click path into rating.
    var pending = state._reviewsLoaded ? findNextUnrated() : null;

    var total = orders.length;
    var totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
    var shown;
    if (!state.ordersExpanded) {
      shown = orders.slice(0, 3);
    } else {
      if (state.ordersPage < 1) state.ordersPage = 1;
      if (state.ordersPage > totalPages) state.ordersPage = totalPages;
      var start = (state.ordersPage - 1) * PAGE_SIZE;
      shown = orders.slice(start, start + PAGE_SIZE);
    }
    list.innerHTML = reviewHintHtml(pending) + shown.map(orderRow).join('');

    if (!state.ordersExpanded) {
      footer.innerHTML = '<button type="button" class="link-orange expand-orders-btn" id="expand-orders">' + esc(T.t('cockpit.show_all_orders', {count: total})) + ' →</button>';
    } else {
      var meta = T.t('cockpit.show_orders_page', {from: ((state.ordersPage - 1) * PAGE_SIZE + 1), to: Math.min(state.ordersPage * PAGE_SIZE, total), total: total});
      footer.innerHTML = '<div class="order-history-footer-meta" aria-live="polite">' + meta + '</div>'
        + '<nav class="pager" aria-label="' + esc(T.cockpit.history_pager_aria) + '">' + pagerBtns(totalPages, state.ordersPage, 'opage') + '</nav>'
        + '<button type="button" class="link-orange collapse-orders-btn" id="collapse-orders">' + esc(T.cockpit.show_less_link) + '</button>';
    }
  }

  // Compute the actual charged amount in shop currency (CHF). Loop's
  // totalPriceUsd is — despite living next to CHF fields — a USD-converted
  // value, so using it as a CHF price was understating/overstating the
  // total. Subtotal − discount + shipping always reconciles to what the
  // customer was charged and what the email shows.
  function orderNetTotal(o) {
    var sub = parseFloat(o.totalLineItemsPrice || 0);
    var disc = parseFloat(o.totalDiscount || 0);
    var ship = parseFloat(o.totalShippingPrice || 0);
    return Math.max(0, sub - disc + ship);
  }

  // Try a few likely field names so we keep working if Loop renames things.
  // Falls back to line.id (Loop's line-item id) so we never lose tracking,
  // even though that ties the review to a specific line rather than the product.
  function lineProductId(line) {
    if (!line) return null;
    // Loop's storefront API uses `productShopifyId` — that's the canonical
    // field. The rest are fallbacks in case Loop renames things or a future
    // line shape differs.
    return line.productShopifyId
        || line.productId
        || line.shopifyProductId
        || line.shopify_product_id
        || (line.product && (line.product.id || line.product.productId))
        || line.product_id
        || null;
  }

  // Dish names come from Loop's subscription lines, which are German-only.
  // On EN/FR, fetch the locale-aware titles once from Shopify (products.json
  // respects the /en|/fr prefix via localized()) and swap them in wherever a
  // dish name renders. On DE this never fires — Loop's titles are already
  // the German originals.
  var dishTitleById = null;   // productShopifyId → translated title
  var dishTitlePromise = null;
  function loadTranslatedDishTitles() {
    if (ttLocaleRoot() === '') return Promise.resolve();
    if (dishTitlePromise) return dishTitlePromise;
    // Der Shop hat weit über 250 published Produkte (wöchentlich rotierendes
    // Menü) — seitenweise laden, bis eine Seite nicht mehr voll ist. Cap bei
    // 5 Seiten (1250 Produkte) als Schutz; ältere Gerichte fallen dann auf
    // den deutschen Loop-Titel zurück.
    dishTitlePromise = (async function () {
      var map = {};
      for (var page = 1; page <= 5; page++) {
        try {
          var res = await fetch(localized('/products.json?limit=250&page=' + page));
          if (!res.ok) break;
          var data = await res.json();
          var ps = (data && data.products) || [];
          ps.forEach(function (p) { map[String(p.id)] = p.title; });
          if (ps.length < 250) break;
        } catch (e) { break; }
      }
      if (Object.keys(map).length) dishTitleById = map;
    })();
    return dishTitlePromise;
  }
  function dishDisplayName(line, fallback) {
    if (dishTitleById) {
      var pid = lineProductId(line);
      if (pid && dishTitleById[String(pid)]) return dishTitleById[String(pid)];
    }
    return (line && (line.productTitle || line.title)) || fallback;
  }

  function findReview(orderId, productId) {
    if (!orderId || !productId) return null;
    var oid = String(orderId), pid = String(productId);
    for (var i = 0; i < state.reviews.length; i++) {
      var r = state.reviews[i];
      if (String(r.shopify_order_id) === oid && String(r.shopify_product_id) === pid) return r;
    }
    return null;
  }

  // Only the N most recent PROCESSED orders can be rated. Skipped orders and
  // anything older than the cutoff render dishes for context but no CTA/stars.
  function isOrderRateable(order) {
    if (!order || order.status !== 'PROCESSED') return false;
    var seen = 0;
    for (var i = 0; i < state.orders.length; i++) {
      var o = state.orders[i];
      if (o.status !== 'PROCESSED') continue;
      seen++;
      if (String(o.id) === String(order.id)) return seen <= RATEABLE_ORDER_LIMIT;
      if (seen >= RATEABLE_ORDER_LIMIT) return false;
    }
    return false;
  }

  function rateableLines(order) {
    if (!isOrderRateable(order)) return [];
    var lines = order.lines || order.lineItems || [];
    return lines.filter(function (l) { return !!lineProductId(l); });
  }

  function countUnrated(order) {
    var lines = rateableLines(order);
    var unrated = 0;
    for (var i = 0; i < lines.length; i++) {
      if (!findReview(order.id, lineProductId(lines[i]))) unrated++;
    }
    return unrated;
  }

  function reviewProgress() {
    var total = 0, done = 0;
    (state.orders || []).forEach(function (o) {
      var lines = rateableLines(o);
      total += lines.length;
      lines.forEach(function (l) {
        if (findReview(o.id, lineProductId(l))) done++;
      });
    });
    return { total: total, done: done };
  }

  // Rating order: OLDEST rateable delivery first, so the customer works
  // forward in time through the open reviews instead of starting at the newest
  // dish. state.orders stays newest-first (the history list and the
  // isOrderRateable window depend on that), so we reverse a filtered copy.
  function rateableOrdersOldestFirst() {
    return (state.orders || []).filter(function (o) { return isOrderRateable(o); }).reverse();
  }

  function findNextUnrated(skipOrderId, skipProductId) {
    var ordered = rateableOrdersOldestFirst();
    for (var i = 0; i < ordered.length; i++) {
      var o = ordered[i];
      var lines = rateableLines(o);
      for (var j = 0; j < lines.length; j++) {
        var l = lines[j];
        var pid = lineProductId(l);
        if (skipOrderId && String(skipOrderId) === String(o.id)
            && skipProductId && String(skipProductId) === String(pid)) continue;
        if (!findReview(o.id, pid)) return { order: o, line: l };
      }
    }
    return null;
  }

  function reviewOpenBadgeText(count) {
    return count === 1
      ? (T.cockpit.review_open_one || '1')
      : T.t('cockpit.review_open_other', { count: count });
  }

  function starsStaticHtml(rating) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<span' + (i <= rating ? '' : ' class="star-empty"') + '>★</span>';
    }
    return out;
  }

  function orderRow(o) {
    var orderNum = o.shopifyOrderNumber ? '#' + o.shopifyOrderNumber : (o.name || ('#' + (o.id || '')));
    var dateSrc = o.shopifyCreatedAt || o.billingDate || o.createdAt;
    var dateObj = dateSrc ? new Date(dateSrc) : null;
    var isSkipped = o.status === 'SKIPPED';
    var statusLabel = isSkipped ? T.cockpit.status_skipped : T.cockpit.order_processed;
    var statusClass = isSkipped ? 'status-amber' : 'status-green';

    // Collapsed row shows the review status instead of the price (the price
    // still appears in the expanded summary): open count in salmon, or a
    // green "Alles bewertet" once every rateable dish has a review.
    var unrated = state._reviewsLoaded ? countUnrated(o) : 0;
    var badge = '';
    if (unrated > 0) {
      badge = '<span class="review-badge">' + esc(reviewOpenBadgeText(unrated)) + '</span>';
    } else if (state._reviewsLoaded && isOrderRateable(o) && rateableLines(o).length) {
      badge = '<span class="review-badge review-badge--done">' + esc(T.cockpit.review_all_rated || '') + '</span>';
    }

    var isOpen = !!state.openOrders[o.id];
    var h = '';
    h += '<div class="order-card" data-order-id="' + esc(o.id) + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '">';
    h += '<div class="order-card__head" role="button" tabindex="0" data-order-toggle="' + esc(o.id) + '" aria-controls="order-body-' + esc(o.id) + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '">';
    h += '<span class="order-card__main">';
    h += '<span class="order-card__id-line"><span class="order-card__id">' + esc(orderNum) + '</span><span class="status-pill ' + statusClass + '">' + statusLabel + '</span></span>';
    if (dateObj) h += '<span class="order-card__date"><time datetime="' + fmtISO(dateObj) + '">' + fmtDDMMYY(dateObj) + '</time></span>';
    h += '</span>';
    h += '<span class="order-card__meta">';
    h += badge;
    h += '</span>';
    h += '<span class="order-card__chevron" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></span>';
    h += '</div>';
    h += '<div class="order-card__body" id="order-body-' + esc(o.id) + '">';
    if (isOpen) h += orderBodyHtml(o);
    h += '</div>';
    h += '</div>';
    return h;
  }

  function orderBodyHtml(o) {
    var isSkipped = o.status === 'SKIPPED';
    var lines = o.lines || o.lineItems || [];
    var h = '';
    if (!lines.length) {
      return '<p style="color:var(--muted); text-align:center; padding:1rem 0; margin:0;">' + esc(T.cockpit.no_details) + '</p>';
    }
    var canRateOrder = isOrderRateable(o);
    lines.forEach(function (l) {
      var name = dishDisplayName(l, T.cockpit.dish_fallback || 'Gericht');
      var imgUrl = l.image ? (l.image.url || l.image) : null;
      var pid = lineProductId(l);
      var review = pid ? findReview(o.id, pid) : null;
      var canRate = canRateOrder && !!pid;

      h += '<div class="dish-review-row" data-product-id="' + esc(pid || '') + '" data-order-id="' + esc(o.id) + '">';
      h += imgUrl
        ? '<img class="dish-review-row__img" src="' + esc(imgUrl) + '" alt="" loading="lazy">'
        : '<div class="dish-review-row__img" aria-hidden="true"></div>';
      h += '<div class="dish-review-row__main">';
      h += '<div class="dish-review-row__name">' + esc(name) + '</div>';
      if (canRate && review) {
        h += '<div class="dish-review-row__state">' + esc(T.cockpit.review_rated) + '</div>';
      } else if (canRate) {
        h += '<div class="dish-review-row__state dish-review-row__state--unrated">' + esc(T.cockpit.review_unrated) + '</div>';
      }
      // Non-rateable orders: dish name only, no state label.
      h += '</div>';
      if (canRate && review) {
        h += '<button type="button" class="stars-static" data-rate-product="' + esc(pid) + '" data-rate-order="' + esc(o.id) + '" aria-label="' + esc(T.cockpit.review_edit_aria || T.cockpit.review_rated) + '">' + starsStaticHtml(review.rating) + '</button>';
      } else if (canRate) {
        h += '<button type="button" class="dish-review-row__cta" data-rate-product="' + esc(pid) + '" data-rate-order="' + esc(o.id) + '">' + esc(T.cockpit.review_rate_cta) + '</button>';
      } else if (review) {
        // Read-only stars for legacy reviews on now-non-rateable orders
        h += '<span class="stars-static" aria-label="' + esc(T.cockpit.review_rated) + '">' + starsStaticHtml(review.rating) + '</span>';
      } else {
        h += '<span></span>';
      }
      h += '</div>';
    });

    if (!isSkipped) {
      var subtotal = parseFloat(o.totalLineItemsPrice || 0);
      var discount = parseFloat(o.totalDiscount || 0);
      var shipping = parseFloat(o.totalShippingPrice || 0);
      var amount = orderNetTotal(o);
      h += '<div class="order-card__summary">';
      h += '<div class="summary-row"><span class="lbl">' + esc(T.cockpit.subtotal_label) + '</span><span class="val">' + fmtCHF(subtotal) + '</span></div>';
      if (discount > 0.01) h += '<div class="summary-row saving"><span class="lbl">' + esc(T.cockpit.discount_label) + '</span><span class="val">– ' + fmtCHF(discount) + '</span></div>';
      if (shipping > 0.01) h += '<div class="summary-row"><span class="lbl">' + esc(T.cockpit.shipping_label || 'Versand') + '</span><span class="val">' + fmtCHF(shipping) + '</span></div>';
      h += '<div class="summary-row total"><span class="lbl">' + esc(T.cockpit.total_label) + '</span><span class="val">' + fmtCHF(amount) + '</span></div>';
      h += '</div>';
    }
    return h;
  }

  function toggleOrderExpand(orderId) {
    var key = String(orderId);
    var card = document.querySelector('.order-card[data-order-id="' + CSS.escape(key) + '"]');
    if (!card) return;
    var willOpen = !state.openOrders[key];
    state.openOrders[key] = willOpen;
    if (willOpen) {
      var o = (state.orders || []).find(function (x) { return String(x.id) === key; });
      if (o) card.querySelector('.order-card__body').innerHTML = orderBodyHtml(o);
    }
    card.setAttribute('aria-expanded', String(willOpen));
    var head = card.querySelector('.order-card__head');
    if (head) head.setAttribute('aria-expanded', String(willOpen));
  }

  function refreshOpenOrderBody(orderId) {
    var card = document.querySelector('.order-card[data-order-id="' + CSS.escape(String(orderId)) + '"]');
    if (!card) return;
    var head = card.querySelector('.order-card__main');
    var o = (state.orders || []).find(function (x) { return String(x.id) === String(orderId); });
    if (!o) return;
    // Update the "X Bewertungen offen" badge after a submit (lives in the
    // meta column, bottom-right, aligned with the price).
    var metaEl = card.querySelector('.order-card__meta');
    if (metaEl) {
      var oldBadge = metaEl.querySelector('.review-badge');
      if (oldBadge) oldBadge.remove();
      var unrated = countUnrated(o);
      if (unrated > 0) {
        metaEl.insertAdjacentHTML('beforeend', '<span class="review-badge">' + esc(reviewOpenBadgeText(unrated)) + '</span>');
      }
    }
    if (state.openOrders[String(orderId)]) {
      card.querySelector('.order-card__body').innerHTML = orderBodyHtml(o);
    }
  }

  // ============================================================
  // REVIEW MODAL
  // ============================================================

  // Build the rating queue: the dish the user clicked, plus every other
  // unrated dish across the rateable orders. The current dish is always first,
  // even if it's already rated (edit case).
  function buildReviewQueue(startOrderId, startProductId) {
    var items = [];
    var seenKey = String(startOrderId) + '|' + String(startProductId);
    function pushItem(o, l) {
      var pid = lineProductId(l);
      items.push({ orderId: String(o.id), productId: String(pid), order: o, line: l });
    }
    // First item: the clicked one
    var startOrder = (state.orders || []).find(function (x) { return String(x.id) === String(startOrderId); });
    if (!startOrder) return [];
    var startLines = startOrder.lines || startOrder.lineItems || [];
    var startLine = startLines.find(function (l) { return String(lineProductId(l)) === String(startProductId); });
    if (!startLine) return [];
    pushItem(startOrder, startLine);

    // Then: all other unrated dishes in rateable orders, oldest delivery first
    rateableOrdersOldestFirst().forEach(function (o) {
      rateableLines(o).forEach(function (l) {
        var pid = lineProductId(l);
        var key = String(o.id) + '|' + String(pid);
        if (key === seenKey) return;
        if (findReview(o.id, pid)) return;
        pushItem(o, l);
      });
    });
    return items;
  }

  function openReviewForLine(orderId, productId) {
    var queue = buildReviewQueue(orderId, productId);
    if (!queue.length) return;
    state.reviewQueue = { items: queue, index: 0 };
    // Fresh session tracker — collects the ratings the customer submits in this
    // run so we can detect an "all 5 stars" session when the queue completes.
    state.reviewSession = { ratings: Object.create(null) };
    renderActiveReviewItem();
    openDialog('review-modal');
  }

  // Render the current queue item into the modal. State is reset per item so
  // the modal looks fresh (stars + comment from the existing review, if any).
  function renderActiveReviewItem() {
    var q = state.reviewQueue;
    if (!q || !q.items[q.index]) return;
    var item = q.items[q.index];
    var existing = findReview(item.orderId, item.productId);
    var orderNum = item.order.shopifyOrderNumber ? '#' + item.order.shopifyOrderNumber
      : (item.order.name || ('#' + item.order.id));
    var imgUrl = item.line.image ? (item.line.image.url || item.line.image) : '';
    var name = dishDisplayName(item.line, T.cockpit.dish_fallback || 'Gericht');

    state.activeReview = {
      orderId: item.orderId,
      productId: item.productId,
      rating: existing ? existing.rating : 0,
      comment: existing ? (existing.comment || '') : '',
      saving: false,
    };

    document.getElementById('review-eyebrow').textContent =
      T.t('cockpit.review_order_label', { num: orderNum });
    document.getElementById('review-dish-name').textContent = name;
    var img = document.getElementById('review-dish-img');
    if (imgUrl) { img.src = imgUrl; img.style.visibility = 'visible'; }
    else { img.removeAttribute('src'); img.style.visibility = 'hidden'; }
    document.getElementById('review-comment').value = state.activeReview.comment;
    document.getElementById('review-progress-count').textContent =
      (q.index + 1) + ' / ' + q.items.length;
    var fillPct = Math.round(((q.index + (state.activeReview.rating ? 1 : 0)) / q.items.length) * 100);
    document.getElementById('review-progress-fill').style.width = fillPct + '%';

    renderReviewStars();
    renderReviewTagsSection();
    updateReviewSubmitState();
  }

  function renderReviewStars() {
    var wrap = document.getElementById('review-stars');
    var rating = state.activeReview ? state.activeReview.rating : 0;
    var h = '';
    for (var i = 1; i <= 5; i++) {
      h += '<button type="button" class="review-star' + (i <= rating ? ' is-on' : '') + '"'
        + ' data-rating="' + i + '"'
        + ' role="radio" aria-checked="' + (i === rating ? 'true' : 'false') + '"'
        + ' aria-label="' + esc(T.t('cockpit.review_star_aria', { n: i })) + '"'
        + '>★</button>';
    }
    wrap.innerHTML = h;
    var hint = document.getElementById('review-star-hint');
    if (rating === 0) {
      hint.textContent = T.cockpit.review_star_hint;
      hint.style.visibility = 'visible';
    } else {
      hint.style.visibility = 'hidden';
    }
  }

  // Chips render the localized label as a quick-insert toggle. Click adds the
  // label to the comment textarea (separator " · "); clicking an active chip
  // removes its label again. No selection state stored on activeReview — the
  // visual state is derived from whatever's in the textarea.
  function renderReviewTagsSection() {
    var section = document.getElementById('review-tags-section');
    if (!state.activeReview || !state.activeReview.rating) {
      section.hidden = true;
      return;
    }
    section.hidden = false;
    var positive = state.activeReview.rating === 5;
    var keys = positive ? REVIEW_POSITIVE_TAGS : REVIEW_IMPROVEMENT_TAGS;
    document.getElementById('review-tags-title').textContent =
      positive ? T.cockpit.review_positive_title : T.cockpit.review_improvement_title;

    var wrap = document.getElementById('review-tags');
    var h = '';
    keys.forEach(function (key) {
      var label = T.cockpit['tag_' + key] || key;
      h += '<button type="button" class="review-tag"'
        + ' data-tag-label="' + esc(label) + '"'
        + ' aria-pressed="false"'
        + '>' + esc(label) + '</button>';
    });
    wrap.innerHTML = h;
    var countEl = document.getElementById('review-tags-count');
    if (countEl) countEl.hidden = true;
    syncChipStatesFromComment();
  }

  // Reflect whether each chip's label currently appears in the comment, so the
  // active styling stays in sync even if the user edits the textarea by hand.
  function syncChipStatesFromComment() {
    var v = document.getElementById('review-comment').value;
    var sep = REVIEW_TAG_SEP;
    var chips = document.querySelectorAll('#review-tags .review-tag');
    for (var i = 0; i < chips.length; i++) {
      var label = chips[i].dataset.tagLabel || chips[i].textContent.trim();
      var active = v === label
        || v.indexOf(label + sep) === 0
        || v.indexOf(sep + label) >= 0;
      chips[i].classList.toggle('is-on', active);
      chips[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function applyChipToComment(label) {
    var t = document.getElementById('review-comment');
    var sep = REVIEW_TAG_SEP;
    var v = t.value;
    if (v === label) {
      t.value = '';
    } else if (v.indexOf(label + sep) === 0) {
      t.value = v.slice(label.length + sep.length);
    } else if (v.indexOf(sep + label) >= 0) {
      var i = v.indexOf(sep + label);
      v = v.slice(0, i) + v.slice(i + sep.length + label.length);
      t.value = v;
    } else {
      t.value = v ? v + sep + label : label;
    }
    syncChipStatesFromComment();
  }

  function setReviewRating(n) {
    if (!state.activeReview) return;
    state.activeReview.rating = n;
    renderReviewStars();
    renderReviewTagsSection();
    updateReviewSubmitState();
    var q = state.reviewQueue;
    if (q) {
      var fillPct = Math.round(((q.index + 1) / q.items.length) * 100);
      document.getElementById('review-progress-fill').style.width = fillPct + '%';
    }
  }

  function updateReviewSubmitState() {
    var btn = document.getElementById('review-submit-btn');
    if (!btn) return;
    btn.disabled = !state.activeReview || !state.activeReview.rating || state.activeReview.saving;
    btn.textContent = (state.activeReview && state.activeReview.saving)
      ? (T.cockpit.review_saving || '…')
      : (T.cockpit.review_done || 'Weiter');
  }

  async function submitActiveReview() {
    if (!state.activeReview || !state.activeReview.rating || state.activeReview.saving) return;
    state.activeReview.saving = true;
    updateReviewSubmitState();
    try {
      var commentEl = document.getElementById('review-comment');
      var comment = commentEl ? commentEl.value.trim() : '';
      var resp = await supabaseFetch('/submit-review', {
        method: 'POST',
        body: {
          order_id: String(state.activeReview.orderId),
          product_id: String(state.activeReview.productId),
          rating: state.activeReview.rating,
          comment: comment || null,
        },
      });
      if (!resp || !resp.review) throw new Error('no_review_returned');

      // Merge the returned row into local state (replace if it already existed).
      var review = resp.review;
      var i = state.reviews.findIndex(function (r) {
        return String(r.shopify_order_id) === String(review.shopify_order_id)
            && String(r.shopify_product_id) === String(review.shopify_product_id);
      });
      if (i >= 0) state.reviews[i] = review;
      else state.reviews.push(review);

      // Track this rating for the current session (overwrites on re-rate).
      if (state.reviewSession) {
        state.reviewSession.ratings[String(review.shopify_order_id) + '|' + String(review.shopify_product_id)] = review.rating;
      }

      refreshOpenOrderBody(state.activeReview.orderId);
      advanceReviewQueue();
    } catch (err) {
      console.error('submit-review failed', err);
      alert(T.cockpit.review_save_error || 'Bewertung konnte nicht gespeichert werden.');
      if (state.activeReview) state.activeReview.saving = false;
      updateReviewSubmitState();
    }
  }

  function advanceReviewQueue() {
    var q = state.reviewQueue;
    if (!q) { closeDialog('review-modal'); return; }
    q.index++;
    // Skip any queued items that have since been rated (e.g. user re-rated an
    // earlier item, or another tab rated something).
    while (q.index < q.items.length && findReview(q.items[q.index].orderId, q.items[q.index].productId)) {
      q.index++;
    }
    if (q.index < q.items.length) {
      renderActiveReviewItem();
    } else {
      var session = state.reviewSession;
      state.reviewQueue = null;
      state.activeReview = null;
      state.reviewSession = null;
      closeDialog('review-modal');
      // Loyal customer who just rated everything 5 stars → ask for a Google
      // review instead of the generic success screen. Otherwise: success screen.
      if (googleReviewShouldPrompt(session)) {
        openGoogleReviewFlyover({ preview: state.googleReviewPreview });
      } else {
        showReviewSuccess();
      }
    }
  }

  function showReviewSuccess() {
    var p = reviewProgress();
    var pct = p.total > 0 ? Math.round((p.done / p.total) * 100) : 0;
    document.getElementById('review-success-progress-label').textContent =
      T.t('cockpit.review_progress', { done: p.done, total: p.total });
    document.getElementById('review-success-progress-pct').textContent = pct + ' %';
    document.getElementById('review-success-progress-bar').style.width = pct + '%';

    // With the queue-driven flow we only reach this state when nothing is left
    // to rate, so the "rate another order" button no longer has a target.
    var rateAnotherBtn = document.getElementById('review-rate-another-btn');
    if (rateAnotherBtn) rateAnotherBtn.hidden = true;

    openDialog('review-success-modal');
  }

  // ============================================================
  // GOOGLE REVIEW PROMPT
  // ============================================================
  // After a customer who is loyal (> 5 orders in the last 3 months) finishes a
  // review session in which they rated every dish 5 stars, we invite them to
  // also leave a Google review. Their answer is remembered server-side:
  //   "Habe ich schon gemacht" / clicked through → 'done'  → never ask again
  //   "Vielleicht später"                        → 'later' → re-ask after 4 weeks

  // Count real (non-skipped) orders processed within the last ~3 months.
  function ordersLast3MonthsCount() {
    var cutoff = Date.now() - GOOGLE_REVIEW_ORDER_WINDOW_MS;
    return (state.orders || []).reduce(function (n, o) {
      if (o && o.status === 'SKIPPED') return n;
      var src = o && (o.shopifyCreatedAt || o.billingDate || o.createdAt);
      var t = src ? new Date(src).getTime() : NaN;
      return (!isNaN(t) && t >= cutoff) ? n + 1 : n;
    }, 0);
  }

  // Has the customer's stored state cleared them to be asked again?
  function googleReviewEligible() {
    var g = state.googleReview;
    if (!g) return true;                       // never interacted → ask
    if (g.status === 'done') return false;     // already reviewed → never again
    if (g.status === 'later') {                // snoozed → only after 4 weeks
      var src = g.last_prompted_at || g.updated_at;
      var t = src ? new Date(src).getTime() : NaN;
      if (isNaN(t)) return true;
      return (Date.now() - t) >= GOOGLE_REVIEW_SNOOZE_MS;
    }
    return true;
  }

  // Should we surface the Google flyover at the end of THIS review session?
  // Per spec (decided with Victor): the customer must have > 5 orders in the last
  // 3 months AND have rated every dish in THIS review session 5★. Earlier sub-5★
  // reviews are deliberately NOT considered.
  function googleReviewShouldPrompt(session) {
    var vals = (session && session.ratings)
      ? Object.keys(session.ratings).map(function (k) { return session.ratings[k]; })
      : [];
    var orders = ordersLast3MonthsCount();
    // Decide + remember WHY, so a test can see exactly which gate blocked it.
    var reason = null;
    if (state.isMerchantView) reason = 'merchant_view';
    else if (!vals.length) reason = 'nothing_rated_this_session';
    // Preview/test mode (?googleReviewPreview=1): any completed session shows the
    // flyover, all real-world conditions bypassed (and buttons won't write to DB).
    else if (state.googleReviewPreview) reason = null;
    else if (!vals.every(function (v) { return v === 5; })) reason = 'session_not_all_5_stars';
    else if (orders <= GOOGLE_REVIEW_MIN_ORDERS) reason = 'too_few_orders_3mo:' + orders;
    else if (!googleReviewEligible()) reason = 'not_eligible:' + ((state.googleReview && state.googleReview.status) || 'unknown');
    try {
      console.info('[google-review] prompt decision:', reason ? ('skip → ' + reason) : 'SHOW',
        { sessionRatings: vals, ordersLast3Mo: orders, stored: state.googleReview, preview: state.googleReviewPreview });
    } catch (e) { /* ignore */ }
    return reason === null;
  }

  // Open the flyover. opts.preview = true → testing mode (forced, no DB writes).
  function openGoogleReviewFlyover(opts) {
    state._googleReviewPreviewOpen = !!(opts && opts.preview);
    state._googleReviewResolved = false; // reset per open (explicit choice vs. dismiss)
    openDialog('google-review-modal');
  }

  // Persist the customer's choice (unless we're in preview mode). We update
  // state.googleReview optimistically BEFORE the request so the snooze/done
  // dedup still holds for this page load even if the write fails.
  function recordGoogleReview(action) {
    if (state._googleReviewPreviewOpen) return; // preview: never touch the DB
    state.googleReview = {
      status: action === 'done' ? 'done' : 'later',
      snooze_count: ((state.googleReview && state.googleReview.snooze_count) || 0) + (action === 'later' ? 1 : 0),
      last_prompted_at: new Date().toISOString(),
    };
    supabaseFetch('/google-review', { method: 'POST', body: { action: action } })
      .then(function (resp) {
        if (resp && resp.prompt) state.googleReview = resp.prompt; // server is authoritative
      })
      .catch(function (err) { console.warn('google-review save failed', err); });
  }

  // The three explicit choices. Each marks the flyover resolved so a follow-up
  // closeDialog() doesn't also log an implicit "später" (see maybeSnoozeGoogleReview).
  function resolveGoogleReview(action) {
    state._googleReviewResolved = true;
    recordGoogleReview(action);
    closeDialog('google-review-modal');
  }

  // "Jetzt auf Google bewerten" — open the review page and treat the click as a
  // strong signal they're reviewing, so we don't nag them again ('done').
  function goToGoogleReview() {
    try { window.open(GOOGLE_REVIEW_URL, '_blank', 'noopener'); }
    catch (e) { window.location.href = GOOGLE_REVIEW_URL; }
    resolveGoogleReview('done');
  }

  // Called whenever the Google flyover closes. If the customer dismissed it
  // without an explicit choice (X / backdrop / Escape), treat it as "Vielleicht
  // später" so the 4-week snooze actually starts — otherwise the easiest
  // dismissals would defeat the throttle and re-prompt next session. No-op in
  // preview mode or after an explicit button choice.
  function maybeSnoozeGoogleReview() {
    if (state._googleReviewResolved || state._googleReviewPreviewOpen) return;
    state._googleReviewResolved = true;
    recordGoogleReview('later');
  }

  function pagerBtns(totalPages, cur, kind) {
    var set = new Set([1, totalPages, cur, cur - 1, cur + 1]);
    var sorted = [].concat(Array.from(set)).filter(function (n) { return n >= 1 && n <= totalPages; }).sort(function (a, b) { return a - b; });
    var items = [];
    items.push('<button type="button" class="pager-btn pager-nav" data-' + kind + '="prev" ' + (cur === 1 ? 'disabled' : '') + ' aria-label="' + esc(T.cockpit.prev_page_aria) + '">‹</button>');
    var prev = 0;
    sorted.forEach(function (n) {
      if (n - prev > 1) items.push('<span class="pager-ellipsis" aria-hidden="true">…</span>');
      items.push('<button type="button" class="pager-btn' + (n === cur ? ' is-current' : '') + '" data-' + kind + '="' + n + '" aria-label="' + esc(T.t('cockpit.page_n_aria', {n: n})) + '"' + (n === cur ? ' aria-current="page"' : '') + '>' + n + '</button>');
      prev = n;
    });
    items.push('<button type="button" class="pager-btn pager-nav" data-' + kind + '="next" ' + (cur === totalPages ? 'disabled' : '') + ' aria-label="' + T.cockpit.next_page_aria + '">›</button>');
    return items.join('');
  }

  // ============================================================
  // DIALOGS
  // ============================================================

  function openDialog(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('open');
    // One history entry per open dialog: back closes it instead of leaving the
    // cockpit. Multi-step flows (video → cancel) therefore step backwards.
    if (window.TTHistory) window.TTHistory.open('dialog:' + id, function () { closeDialog(id); });
    var focusTarget = d.querySelector('input, button, [tabindex]');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
  }
  function closeDialog(id) {
    var d = document.getElementById(id);
    if (!d) return;
    // Dismissing the Google flyover (X / backdrop) counts as "Vielleicht später".
    if (id === 'google-review-modal' && d.classList.contains('open')) maybeSnoozeGoogleReview();
    d.classList.remove('open');
    d.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } });
    if (window.TTHistory) window.TTHistory.close('dialog:' + id);
  }
  function closeAllDialogs() {
    document.querySelectorAll('.dialog-overlay.open').forEach(function (d) {
      // Escape on the Google flyover counts as "Vielleicht später" too.
      if (d.id === 'google-review-modal') maybeSnoozeGoogleReview();
      d.classList.remove('open');
      d.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } });
    });
    if (window.TTHistory) window.TTHistory.closeAll();
  }

  // ── Address dialog
  function openAddressDialog() {
    // Reset the save button — saveAddress() can leave it disabled with the
    // "Speichern…" label (success path skips the reset, and a stale error
    // reset only fires on failure), so without this a second open after an
    // earlier save would show a dead, greyed-out button.
    var saveBtn = document.getElementById('adr-save-btn');
    if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = T.cockpit.addr_save; }
    var addr = (state.subscription && state.subscription.shippingAddress) || {};
    document.getElementById('adr-first').value = addr.firstName || '';
    document.getElementById('adr-last').value = addr.lastName || '';
    document.getElementById('adr-street').value = addr.address1 || '';
    document.getElementById('adr-extra').value = addr.address2 || '';
    document.getElementById('adr-zip').value = addr.zip || '';
    document.getElementById('adr-city').value = addr.city || '';
    document.getElementById('adr-phone').value = addr.phone || '';
    document.getElementById('adr-error').style.display = 'none';
    openDialog('address-dialog');
  }

  async function saveAddress() {
    var btn = document.getElementById('adr-save-btn');
    var errEl = document.getElementById('adr-error');
    btn.disabled = true;
    btn.textContent = T.cockpit.saving_short;
    errEl.style.display = 'none';
    var addr = (state.subscription && state.subscription.shippingAddress) || {};
    var next = {
      firstName: document.getElementById('adr-first').value.trim(),
      lastName: document.getElementById('adr-last').value.trim(),
      address1: document.getElementById('adr-street').value.trim(),
      address2: document.getElementById('adr-extra').value.trim(),
      zip: document.getElementById('adr-zip').value.trim(),
      city: document.getElementById('adr-city').value.trim(),
      phone: document.getElementById('adr-phone').value.trim(),
      countryCode: addr.countryCode || 'CH',
    };
    if (addr.provinceCode) next.provinceCode = addr.provinceCode;
    if (addr.company) next.company = addr.company;
    var required = ['firstName', 'lastName', 'address1', 'zip', 'city', 'phone'];
    for (var i = 0; i < required.length; i++) {
      if (!next[required[i]]) {
        errEl.textContent = T.cockpit.save_addr_required;
        errEl.style.display = '';
        btn.disabled = false;
        btn.textContent = T.cockpit.addr_save;
        return;
      }
    }
    try {
      await apiFetch('/subscription/' + state.subscription.id + '/address', { method: 'PUT', body: next });
      closeDialog('address-dialog');
      try {
        // The address is already saved server-side at this point — a failure
        // refreshing the cockpit afterwards must not look like the save
        // itself failed. silentRefresh keeps loadData() from swapping the
        // whole cockpit for the full-page error screen; worst case the
        // displayed address is stale until the next natural reload.
        await loadData({ silentRefresh: true });
      } catch (refreshErr) {
        console.warn('Post-save cockpit refresh failed', refreshErr);
      }
    } catch (e) {
      errEl.textContent = e.message || T.cockpit.save_addr_failed;
      errEl.style.display = '';
      btn.disabled = false;
      btn.textContent = T.cockpit.addr_save;
    }
  }

  // Resolve the next still-future, non-skipped scheduled order. Shared by the
  // skip flow and the cancel-dialog "skip instead" option so they always target
  // the same delivery the hero shows. `state.scheduledOrders` is not sorted, so
  // we sort before picking (mirrors render()'s comingOrder). Returns undefined
  // when there's nothing left to skip.
  function getNextSkippableOrder() {
    return (state.comingOrder && state.comingOrder.status !== 'SKIPPED')
      ? state.comingOrder
      : (state.scheduledOrders || []).slice()
          .sort(function (a, b) {
            return new Date(a.billingDate || a.nextBillingDate) - new Date(b.billingDate || b.nextBillingDate);
          })
          .find(function (o) {
            if (o.status === 'SKIPPED') return false;
            var d = new Date(o.billingDate || o.nextBillingDate);
            return !isNaN(d.getTime()) && d >= new Date(Date.now() - 36e5);
          });
  }
  // Open the skip dialog for that order. Shared by the hero "Lieferung
  // überspringen" button and the "Nächste Lieferung auslassen" button in the
  // manage section.
  function skipUpcomingDelivery() {
    var nextOrder = getNextSkippableOrder();
    if (!nextOrder) return;
    var sched = getDeadlineAndDelivery(nextOrder.billingDate || nextOrder.nextBillingDate);
    openSkipDialog(nextOrder.id, sched.delivery ? fmtDayLong(sched.delivery) : '');
  }

  // ── Skip dialog
  function openSkipDialog(orderId, dateText) {
    state.pendingSkipOrderId = orderId;
    document.getElementById('skip-dialog-date').textContent = dateText || '—';
    // Reset the confirm button — confirmSkip() leaves it disabled with the
    // "Wird übersprungen…" label after a successful skip, so without this
    // a second skip would open the dialog with a dead, greyed-out button
    // and the screen looked blocked.
    var btn = document.getElementById('skip-confirm-btn');
    if (btn) { btn.disabled = false; btn.textContent = T.cockpit.skip_confirm; }
    openDialog('skip-dialog');
  }
  async function confirmSkip() {
    var orderId = state.pendingSkipOrderId;
    if (!orderId) { closeDialog('skip-dialog'); return; }
    var btn = document.getElementById('skip-confirm-btn');
    btn.disabled = true;
    btn.textContent = T.cockpit.skipping;
    try {
      await apiFetch('/order/' + orderId + '/skip', { method: 'POST' });
      closeDialog('skip-dialog');
      openReasonDialog('skip', {
        subscription_id: state.subscription && state.subscription.id,
        order_id: orderId,
      });
      await loadData();
    } catch (e) {
      btn.textContent = T.cockpit.error_retry;
      btn.disabled = false;
    }
  }

  // ── Reason box — shown after a skip or pause succeeds. The picked reason is
  // logged to Supabase (subscription_events) via the log-subscription-event
  // edge function. Fire-and-forget: a failed log must never block the customer.
  function logSubscriptionEvent(payload) {
    // The edge function stores these columns as text and ignores non-string
    // values, so coerce the ids (Loop returns them as numbers) before sending —
    // otherwise loop_subscription_id / shopify_order_id land as null.
    var p = {};
    for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) p[k] = payload[k]; }
    if (p.subscription_id != null) p.subscription_id = String(p.subscription_id);
    if (p.order_id != null) p.order_id = String(p.order_id);
    if (p.reason_key != null) p.reason_key = String(p.reason_key);
    try {
      supabaseFetch('/log-subscription-event', { method: 'POST', body: p })
        .catch(function (e) { console.warn('event log failed', e); });
    } catch (e) { console.warn('event log failed', e); }
  }
  var REASON_COOLDOWN_MS = 30 * 60 * 1000;
  function openReasonDialog(eventType, ctx) {
    // One answer per episode: a multi-week vacation means several skips in a
    // row, and re-asking after every single one logged the same "Ferien" 3–4×
    // for ONE holiday — event counts then overstate vacation vs. one-off
    // reasons. After a submitted answer we stay quiet for 30 minutes per event
    // type; dismissing without answering does not arm the cooldown.
    var last = parseInt(localStore.getItem('tt_reason_done_' + eventType), 10);
    if (last && Date.now() - last < REASON_COOLDOWN_MS) {
      // Still log the action itself, just without a reason: the backoffice
      // derives the skip quote of its production forecast from these rows
      // (one row = one skipped order). When the cooldown swallowed the row,
      // a three-week holiday counted as one skip and the forecast planned a
      // third too many portions (KW 36–38/2026). The backoffice keeps
      // `not_asked` rows out of the reason statistics.
      logSubscriptionEvent({
        event_type: eventType,
        subscription_id: (ctx && ctx.subscription_id) || null,
        order_id: (ctx && ctx.order_id) || null,
        reason_key: 'not_asked',
        reason_label: null,
        comment: null,
      });
      return;
    }
    state.reasonCtx = { event_type: eventType, subscription_id: (ctx && ctx.subscription_id) || null, order_id: (ctx && ctx.order_id) || null };
    state.reasonChoice = null;
    var sub = document.getElementById('reason-dialog-sub');
    if (sub) sub.textContent = eventType === 'pause' ? T.cockpit.reason_dialog_sub_pause : T.cockpit.reason_dialog_sub_skip;
    // Shuffle the options ("Anderer Grund" stays last): with a fixed order the
    // first — and only blame-free — option ("im Urlaub") collects a primacy
    // bias on top of its real share.
    var wrap = document.getElementById('reason-options');
    if (wrap) {
      var otherBtn = wrap.querySelector('.cancel-reason[data-reason-key="other"]');
      var movable = Array.prototype.slice.call(wrap.querySelectorAll('.cancel-reason'))
        .filter(function (b) { return b !== otherBtn; });
      for (var i = movable.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = movable[i]; movable[i] = movable[j]; movable[j] = tmp;
      }
      movable.forEach(function (b) { wrap.insertBefore(b, otherBtn); });
    }
    document.querySelectorAll('#reason-options .cancel-reason').forEach(function (el) {
      el.classList.remove('active');
      el.setAttribute('aria-checked', 'false');
    });
    var ta = document.getElementById('reason-comment');
    if (ta) { ta.value = ''; ta.style.display = 'none'; }
    var btn = document.getElementById('reason-submit-btn');
    if (btn) { btn.disabled = true; btn.textContent = T.cockpit.reason_submit; }
    openDialog('reason-dialog');
  }
  function selectReason(key) {
    state.reasonChoice = key;
    document.querySelectorAll('#reason-options .cancel-reason').forEach(function (el) {
      var active = el.dataset.reasonKey === key;
      el.classList.toggle('active', active);
      el.setAttribute('aria-checked', String(active));
    });
    var ta = document.getElementById('reason-comment');
    if (ta) {
      ta.style.display = key === 'other' ? '' : 'none';
      if (key === 'other') setTimeout(function () { ta.focus(); }, 50);
    }
    var btn = document.getElementById('reason-submit-btn');
    if (btn) btn.disabled = false;
  }
  function submitReason() {
    var ctx = state.reasonCtx;
    var key = state.reasonChoice;
    if (!ctx || !key) { closeDialog('reason-dialog'); return; }
    var labels = {
      away_vacation: T.cockpit.reason_away,
      no_need: T.cockpit.reason_no_need,
      bad_selection: T.cockpit.reason_bad_selection,
      other: T.cockpit.reason_other,
    };
    var ta = document.getElementById('reason-comment');
    var comment = (key === 'other' && ta) ? ta.value.trim() : '';
    logSubscriptionEvent({
      event_type: ctx.event_type,
      subscription_id: ctx.subscription_id,
      order_id: ctx.order_id,
      reason_key: key,
      reason_label: labels[key] || key,
      comment: comment || null,
    });
    localStore.setItem('tt_reason_done_' + ctx.event_type, String(Date.now()));
    closeDialog('reason-dialog');
    showToast(T.cockpit.reason_thanks);
  }

  // ── Pause dialog
  function openPauseDialog() {
    state.pauseWeeks = 1;
    // Reset UI — only the weeks selector remains (the date tab was removed).
    document.querySelectorAll('.pause-week').forEach(function (w) {
      var active = parseInt(w.dataset.weeks, 10) === 1;
      w.classList.toggle('active', active);
      w.setAttribute('aria-checked', String(active));
    });
    updatePauseCta();
    openDialog('pause-dialog');
  }
  function setPauseWeeks(n) {
    state.pauseWeeks = n;
    document.querySelectorAll('.pause-week').forEach(function (w) {
      var active = parseInt(w.dataset.weeks, 10) === n;
      w.classList.toggle('active', active);
      w.setAttribute('aria-checked', String(active));
    });
    updatePauseCta();
  }
  function updatePauseCta() {
    var btn = document.getElementById('pause-confirm-btn');
    var info = document.getElementById('pause-next-date');
    // The weeks selector always has a valid selection (default 1), so the
    // confirm is always actionable — re-enable it in case a prior pause attempt
    // left it disabled (greyed-out bug).
    btn.disabled = false;
    btn.textContent = state.pauseWeeks === 1
      ? T.t('cockpit.pause_for_n_weeks', {count: 1, unit: T.weekUnit(1)})
      : T.t('cockpit.pause_for_n_weeks_plural', {count: state.pauseWeeks});
    // Always measure from today. Adjusting an existing pause RESETS it
    // (a fresh N-week pause from now) rather than extending the current
    // one — mirrors confirmPause, which pauses for N weeks (pauseDuration)
    // from today. The next delivery is the first Wednesday AFTER the resume date
    // (deliveries always land on Wednesday).
    var d = new Date();
    d.setDate(d.getDate() + 7 * state.pauseWeeks);
    info.textContent = fmtDayLong(nextWednesdayAfter(d));
  }
  async function confirmPause() {
    var btn = document.getElementById('pause-confirm-btn');
    // Adjusting an existing pause vs. pausing for the first time.
    var wasPaused = !!(state.subscription && state.subscription.status === 'PAUSED');
    btn.disabled = true;
    btn.textContent = T.cockpit.pausing;
    try {
      // Loop's pause endpoint schedules the automatic resume from a DURATION
      // (the pauseDuration object), NOT from an absolute date. There is no
      // "autoResumeDate" field on the API — sending it was silently ignored, so
      // every pause became "indefinite" (no auto-resume, no later "resumed"
      // event). We send pauseDuration in WEEK units (the dialog only offers a
      // week count now). resumeDate, the ISO yyyy-mm-dd, is kept only for the
      // local display stash below.
      // NB: pauseDuration is honoured only for the duration options enabled in
      // Loop's "Pause subscription interval" customer-portal preference.
      var t = new Date();
      t.setDate(t.getDate() + 7 * state.pauseWeeks);
      var resumeDate = t.toISOString().slice(0, 10);
      var pauseDuration = { intervalType: 'WEEK', intervalCount: state.pauseWeeks };
      // Loop's pause endpoint only accepts an ACTIVE subscription, so a paused
      // sub can't be "re-paused" with a new date directly (that returned the
      // "Fehler – erneut versuchen"). When adjusting an existing pause, resume
      // first so the sub is active again, then pause with the new resume date.
      // (We deliberately skip resumeSubscription()'s reschedule step — the
      // immediate re-pause makes any recomputed billing date moot.)
      if (wasPaused) {
        // Tolerate a resume error here: if a previous attempt already resumed
        // (pause failed afterwards) the sub is active and Loop rejects a second
        // resume — we still want to proceed to pause. A genuine resume outage
        // just makes the pause below fail, which surfaces the retry message.
        // NB: no assignDishesAfterReturn() here on purpose — this resume is only
        // a technical step to re-pause with a new date. The customer stays
        // paused, so there is no upcoming box to fill.
        try {
          await apiFetch('/subscription/' + state.subscription.id + '/resume', { method: 'POST', body: {} });
        } catch (e) { /* proceed to pause regardless */ }
      }
      await apiFetch('/subscription/' + state.subscription.id + '/pause', {
        method: 'POST',
        body: { pauseDuration: pauseDuration },
      });
      // Stash the resume date locally as a safety net — Loop's GET response
      // sometimes omits the resume date or returns it under a name we don't
      // know, which would leave the cockpit showing "—" for next delivery.
      try {
        localStore.setItem('tt_pause_resume_' + state.subscription.id, resumeDate);
      } catch (e) { /* private mode etc. */ }
      closeDialog('pause-dialog');
      // Only collect a pause reason on a FRESH pause — not when merely adjusting
      // the resume date of an already-paused subscription.
      if (!wasPaused) {
        openReasonDialog('pause', { subscription_id: state.subscription && state.subscription.id });
      }
      await loadData();
    } catch (e) {
      btn.textContent = 'Fehler – erneut versuchen';
      btn.disabled = false;
    }
  }
  async function resumeSubscription() {
    var btn = document.getElementById('btn-resume');
    if (btn) { btn.disabled = true; btn.textContent = T.cockpit.activating; }
    try {
      await apiFetch('/subscription/' + state.subscription.id + '/resume', { method: 'POST', body: {} });
      try { localStore.removeItem('tt_pause_resume_' + state.subscription.id); } catch (e) { /* noop */ }
      // Loop resumes "based on the original schedule", which can leave the next
      // billing weeks out (the paused cycles are dropped). The customer expects
      // resuming to bring back their soonest delivery, so pull the next billing
      // to the earliest order date Loop accepts (>=24h ahead). Best-effort: a
      // failure just leaves Loop's default date in place.
      try {
        var fri = soonestReschedulableBilling();
        await apiFetch('/subscription/' + state.subscription.id + '/reschedule', {
          method: 'POST',
          body: { newBillingDateEpoch: Math.floor(fri.getTime() / 1000), timezone: 'Europe/Zurich' },
        });
      } catch (e) { console.warn('reschedule after resume failed', e); }
      // Only now: the reschedule above fixes the next billing date, and that
      // date decides which menu week the box is filled from.
      await assignDishesAfterReturn();
      await loadData();
    } catch (e) {
      if (btn) { btn.textContent = T.common.error; btn.disabled = false; }
    }
  }
  var _reactivating = false;
  async function reactivateSubscription(triggerBtn) {
    if (!state.subscription || _reactivating) return;
    _reactivating = true;
    // Disable all reactivate buttons + show loading on the clicked one
    var allBtns = document.querySelectorAll('#btn-reactivate, [data-action="reactivate"]');
    allBtns.forEach(function (b) { b.disabled = true; });
    if (triggerBtn) triggerBtn.classList.add('btn-loading');
    try {
      // Try reactivate, fall back to uncancel (Loop API variants)
      try {
        await apiFetch('/subscription/' + state.subscription.id + '/reactivate', { method: 'POST', body: {} });
      } catch (e1) {
        await apiFetch('/subscription/' + state.subscription.id + '/uncancel', { method: 'POST', body: {} });
      }
      // A reactivated subscription still carries the dishes of the week it was
      // cancelled in — let the backoffice fill the box with the current week's.
      await assignDishesAfterReturn();
      await loadData();
    } catch (e) {
      console.error('Reactivate failed', e);
      showToast(T.cockpit.reactivate_failed);
      allBtns.forEach(function (b) { b.disabled = false; });
      if (triggerBtn) triggerBtn.classList.remove('btn-loading');
    } finally {
      _reactivating = false;
    }
  }

  // ── Payment dialog
  function openPaymentDialog() {
    renderPmList();
    hidePmFeedback();
    var btn = document.getElementById('pm-update-btn');
    if (btn) {
      btn.disabled = false;
      btn.classList.remove('btn-loading');
      btn.textContent = T.cockpit.payment_update_btn;
    }
    openDialog('payment-dialog');
  }
  // Only renders the currently active card (the one Loop bills against).
  // Loop has no DELETE endpoint, so listing every card the customer has
  // ever stored creates clutter the user can't clean up. The "Karte
  // ersetzen" flow POSTs a new card and auto-promotes it to primary,
  // so the visible card always reflects what's actually being billed.
  function renderPmList() {
    var list = document.getElementById('pm-list');
    var sub = state.subscription;
    var activeId = sub ? (sub.customerPaymentMethodId || sub.paymentMethodId) : null;
    var pms = state.paymentMethods || [];
    var activeIdNum = activeId != null ? Number(activeId) : null;
    // Prefer the primary card, fall back to the newest pm if Loop didn't
    // resolve a primary yet (e.g. brand-new sub before first charge).
    var primary = activeIdNum != null
      ? pms.find(function (p) { return Number(p.id) === activeIdNum; })
      : null;
    if (!primary && pms.length) {
      primary = pms.slice().sort(function (a, b) {
        return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
      })[0];
    }

    if (!primary) {
      list.innerHTML = '<div class="pm-empty">' + esc(T.cockpit.no_payment_methods) + '</div>';
      return;
    }

    var isPaypal = primary.type === 'CustomerPaypalBillingAgreement';
    var card = primary.card || {};
    var bk = isPaypal ? 'paypal' : brandKey(card.brand || primary.brand);
    var digits = card.lastDigits || card.last4 || primary.lastDigits || '';
    var expMonth = card.expiryMonth || primary.expiryMonth;
    var expYear = card.expiryYear || primary.expiryYear;
    var nameHtml = isPaypal
      ? 'PayPal'
      : esc(brandName(bk)) + (digits ? ' ···· <span translate="no">' + esc(digits) + '</span>' : '');
    var subHtml = isPaypal
      ? ((primary.payPal && primary.payPal.email) ? esc(primary.payPal.email) : '')
      : ((expMonth && expYear) ? T.t('cockpit.valid_until_full', {month: String(expMonth).padStart(2, '0'), year: String(expYear).slice(-2)}) : '');

    var h = '';
    h += '<div class="pm-card pm-card-solo is-primary" data-pm-id="' + esc(primary.id) + '">';
    h += '<div class="pm-body">';
    h += '<div class="pm-brand pm-brand-' + bk + '" aria-hidden="true">' + brandLabel(bk) + '</div>';
    h += '<div class="pm-text">';
    h += '<div class="pm-name">' + nameHtml + '</div>';
    if (subHtml) h += '<div class="pm-sub">' + subHtml + '</div>';
    h += '</div></div>';
    h += '</div>';
    list.innerHTML = h;
  }
  // ── Card-update flow
  // Loop ships a documented Storefront endpoint that emails the customer a
  // secure update link. We hand the active pmId to that endpoint and let
  // Loop's hosted form do the actual PAN/CVV capture — PCI scope stays
  // on Loop's side. POST /paymentMethod/{pmId}/update with the customer's
  // Bearer token, no admin token needed.

  function showPmFeedback(kind, msg) {
    var fb = document.getElementById('pm-feedback');
    fb.style.display = '';
    if (kind === 'error') {
      fb.style.background = 'var(--red-bg)';
      fb.style.color = 'var(--red)';
    } else if (kind === 'success') {
      fb.style.background = 'var(--green-bg)';
      fb.style.color = 'var(--green)';
    } else {
      fb.style.background = 'rgba(255,143,110,0.12)';
      fb.style.color = 'var(--black)';
    }
    fb.textContent = msg;
  }
  function hidePmFeedback() {
    var fb = document.getElementById('pm-feedback');
    if (fb) fb.style.display = 'none';
  }

  // Resolve the pmId Loop should attach the new card to. Loop's
  // /paymentMethod/{pmId}/update endpoint expects an existing pm —
  // it sends an email with a hosted form whose result replaces (or
  // augments, depending on Loop's internals) the referenced pm.
  function getUpdateTargetPmId() {
    var sub = state.subscription;
    var activeId = sub ? (sub.customerPaymentMethodId || sub.paymentMethodId) : null;
    var pms = state.paymentMethods || [];
    var byActive = activeId != null
      ? pms.find(function (p) { return Number(p.id) === Number(activeId); })
      : null;
    var primary = byActive || pms.slice().sort(function (a, b) {
      return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
    })[0] || null;
    return primary ? Number(primary.id) : null;
  }

  async function sendPaymentUpdateMail() {
    var btn = document.getElementById('pm-update-btn');
    hidePmFeedback();

    var pmId = getUpdateTargetPmId();
    if (!Number.isFinite(pmId)) {
      showPmFeedback('error', T.cockpit.payment_update_no_card);
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.classList.add('btn-loading');
    }
    showPmFeedback('info', T.cockpit.payment_update_sending);

    try {
      await apiFetch('/paymentMethod/' + pmId + '/update', { method: 'POST' });
      var email = state.customer && state.customer.email ? state.customer.email : '';
      var msg = email
        ? T.t('cockpit.payment_update_sent', { email: email })
        : T.cockpit.payment_update_sent_no_email;
      showPmFeedback('success', msg);
    } catch (e) {
      showPmFeedback('error', (e && e.message) || T.cockpit.payment_update_failed);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('btn-loading');
      }
    }
  }

  async function setPrimaryPaymentMethod(rawPmId) {
    if (!state.subscription) return;
    // Loop's API rejects string IDs with "Expected number, received string",
    // and dataset values always come in as strings.
    var pmId = Number(rawPmId);
    if (!Number.isFinite(pmId)) return;
    showPmFeedback('info', T.cockpit.switching);
    try {
      await apiFetch('/subscription/' + state.subscription.id + '/paymentMethod', { method: 'PUT', body: { paymentMethodId: pmId } });
      state.subscription.customerPaymentMethodId = pmId;
      state.subscription.paymentMethodId = pmId;
      renderPmList();
      renderPrimaryPaymentMethod();
      showPmFeedback('success', T.cockpit.primary_updated);
      setTimeout(hidePmFeedback, 2500);
    } catch (e) {
      showPmFeedback('error', e.message || T.cockpit.error_switching);
    }
  }

  // Loop's /paymentMethod/{pmId}/update endpoint creates a brand-new pmId
  // when the customer submits the hosted update form — it does NOT promote
  // the new card to be the subscription's billing card automatically. So on
  // every cockpit load we look for a payment method that's newer than the
  // one the subscription is pointing at and promote it. Without that, the
  // cockpit keeps showing (and Loop keeps billing) the previous card after
  // an "update card" round-trip.
  //
  // Loop's storefront API does not expose createdAt on payment methods, but
  // pmIds are monotonically increasing inside Loop's database, so highest
  // numeric id reliably == most recently created.
  function findNewestPmId(pms) {
    if (!pms || !pms.length) return null;
    var max = 0;
    for (var i = 0; i < pms.length; i++) {
      var id = Number(pms[i].id);
      if (Number.isFinite(id) && id > max) max = id;
    }
    return max || null;
  }

  async function autoPromoteNewestPaymentMethod() {
    var sub = state.subscription;
    if (!sub) return;
    var pms = state.paymentMethods || [];
    if (pms.length < 2) return;
    var currentPmId = Number(sub.customerPaymentMethodId || sub.paymentMethodId);
    var newestPmId = findNewestPmId(pms);
    if (!newestPmId || newestPmId === currentPmId) return;
    try {
      await apiFetch('/subscription/' + sub.id + '/paymentMethod', {
        method: 'PUT',
        body: { paymentMethodId: newestPmId },
      });
      sub.customerPaymentMethodId = newestPmId;
      sub.paymentMethodId = newestPmId;
      logAuth('autopromote_ok', { from: currentPmId || null, to: newestPmId });
    } catch (e) {
      // Promotion failed but the rest of the cockpit is still usable —
      // surface in console for monitoring, but don't break loadData.
      logAuth('autopromote_failed', { error: (e && e.message) || 'unknown' });
    }
  }

  // ── Coupon remove dialog
  function openCouponRemoveDialog(discountId, code, label) {
    document.getElementById('coupon-remove-name').textContent = '«' + label + '»';
    var btn = document.getElementById('coupon-remove-confirm-btn');
    btn.onclick = async function () {
      btn.disabled = true;
      btn.textContent = T.cockpit.removing;
      try {
        // Loop Storefront API: DELETE /subscription/{subId}/discount/{discountShopifyId}
        // GID format `gid://shopify/...` contains `/` — must be URL-encoded.
        await apiFetch('/subscription/' + state.subscription.id + '/discount/' + encodeURIComponent(discountId), { method: 'DELETE' });
        closeDialog('coupon-remove-dialog');
        await loadData();
        showToast(T.t('cockpit.coupon_removed', {label: label}));
      } catch (e) {
        btn.textContent = 'Fehler – erneut versuchen';
        btn.disabled = false;
      }
    };
    openDialog('coupon-remove-dialog');
  }

  // ── Pre-cancel confirmation (video)
  function openPreCancelDialog() {
    var video = document.getElementById('pre-cancel-video');
    var toggle = document.getElementById('pre-cancel-sound-toggle');
    if (video) {
      try { video.currentTime = 0; } catch (e) { /* ignore */ }
      // Try unmuted first (user clicked "Abo beenden" so we're inside a
      // user gesture). If the browser still blocks it, fall back to
      // muted autoplay and let the user unmute via the toggle.
      video.muted = false;
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          video.muted = true;
          if (toggle) {
            toggle.classList.add('is-muted');
            toggle.setAttribute('aria-pressed', 'false');
            toggle.setAttribute('aria-label', T.cockpit.sound_on);
          }
          var p2 = video.play();
          if (p2 && p2.catch) p2.catch(function () { /* autoplay fully blocked */ });
        });
      }
    }
    if (toggle) {
      toggle.classList.remove('is-muted');
      toggle.setAttribute('aria-pressed', 'true');
      toggle.setAttribute('aria-label', T.cockpit.sound_off);
    }
    openDialog('pre-cancel-dialog');
  }
  function closePreCancelDialog() {
    var video = document.getElementById('pre-cancel-video');
    if (video) { try { video.pause(); } catch (e) { /* ignore */ } }
    closeDialog('pre-cancel-dialog');
  }

  // ── Cancel flow — reasons + retention driven by Loop's customer-portal
  // endpoint GET /subscription/{id}/cancellationFlow. Each reason has: id,
  // reason, show{Pause,Skip,Swap,Delay}Action flags, actionMessage (merchant-
  // authored retention HTML) and confirmationMessage. The cancel call sends the
  // chosen reason's id as `cancellationFlowId` plus an optional `comment`.
  // NOTE: the store-level /cancellationFlow is admin-context and is rejected for
  // real customer tokens — the per-subscription endpoint is the correct one.
  //
  // Substitute Loop's merchant-text placeholders (e.g. {{customer_first_name}})
  // in retention HTML. Values are HTML-escaped before insertion.
  function fillLoopVars(htmlStr) {
    if (!htmlStr) return htmlStr || '';
    var c = state.customer || {};
    var map = {
      customer_first_name: c.firstName || '',
      customer_last_name: c.lastName || '',
      customer_name: ((c.firstName || '') + ' ' + (c.lastName || '')).trim(),
      customer_email: c.email || ''
    };
    return String(htmlStr).replace(/\{\{\s*([\w.]+)\s*\}\}/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? esc(map[key]) : m;
    });
  }
  async function ensureCancelReasons() {
    if (state.cancelReasons && state.cancelReasons.length) return state.cancelReasons;
    var sub = state.subscription;
    if (!sub || !sub.id) { state.cancelReasons = []; return state.cancelReasons; }
    try {
      var data = await apiFetch('/subscription/' + sub.id + '/cancellationFlow');
      state.cancelReasons = Array.isArray(data) ? data : (data && data.data ? data.data : []);
    } catch (e) {
      state.cancelReasons = [];
    }
    return state.cancelReasons;
  }
  function renderCancelReasons() {
    var wrap = document.getElementById('cancel-reasons');
    if (!wrap) return;
    var reasons = state.cancelReasons || [];
    if (!reasons.length) {
      wrap.innerHTML = '<p style="color:var(--muted);text-align:center;padding:1rem 0;margin:0;">'
        + esc(T.common.error_loading || '…') + '</p>';
      return;
    }
    var chev = '<svg class="cancel-reason-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    wrap.innerHTML = reasons.map(function (r) {
      return '<button type="button" class="cancel-reason" data-reason-id="' + esc(r.id) + '" role="radio" aria-checked="false">'
        + '<span>' + esc(r.reason) + '</span>' + chev + '</button>';
    }).join('');
  }
  async function openCancelDialog() {
    var commentEl = document.getElementById('cancel-comment');
    if (commentEl) { commentEl.value = ''; commentEl.removeAttribute('aria-invalid'); }
    var finalBtn = document.getElementById('final-cancel-btn');
    if (finalBtn) { finalBtn.disabled = false; finalBtn.textContent = T.cockpit.cancel_final; }
    // Retention alternatives above the cancel reason — only offer what's
    // actually applicable: pause unless the sub is already paused/cancelled,
    // skip only when there's still an upcoming delivery to skip.
    var status = state.subscription ? state.subscription.status : null;
    var canPause = !!status && status !== 'PAUSED' && status !== 'CANCELLED';
    var canSkip = !!getNextSkippableOrder();
    var pauseOpt = document.getElementById('cancel-keep-pause');
    var skipOpt = document.getElementById('cancel-keep-skip');
    var keepWrap = document.getElementById('cancel-keep-options');
    var keepSep = document.getElementById('cancel-keep-sep');
    if (pauseOpt) pauseOpt.hidden = !canPause;
    if (skipOpt) skipOpt.hidden = !canSkip;
    if (keepWrap) keepWrap.hidden = !(canPause || canSkip);
    if (keepSep) keepSep.hidden = !(canPause || canSkip);
    openDialog('confirm-dialog');
    if (commentEl) setTimeout(function () { commentEl.focus(); }, 50);
    // Load Loop's cancellation flow in the background. We no longer show the
    // reason list (the customer just types a free-text reason), but Loop's
    // /cancel still REQUIRES a cancellationFlowId, so we need a default id.
    ensureCancelReasons();
  }
  // Loop's /cancel requires a cancellationFlowId even though we capture the real
  // reason as free text. Pick a sensible default: a reason that reads like
  // "other", else the first configured one.
  function pickDefaultCancelFlowId() {
    var reasons = state.cancelReasons || [];
    if (!reasons.length) return null;
    var other = reasons.find(function (r) {
      return /(other|ander|sonstig|autre)/i.test(String(r.reason || ''));
    });
    return (other || reasons[0]).id;
  }
  async function finalCancel() {
    var btn = document.getElementById('final-cancel-btn');
    var commentEl = document.getElementById('cancel-comment');
    var comment = commentEl ? commentEl.value.trim() : '';
    // Kündigungsgrund ist Pflicht – ohne Grund keine Kündigung.
    if (!comment) {
      if (commentEl) {
        commentEl.setAttribute('aria-invalid', 'true');
        commentEl.focus();
      }
      showToast(T.cockpit.cancel_reason_required || 'Bitte gib kurz deinen Kündigungsgrund an 🙏');
      return;
    }
    btn.disabled = true;
    btn.textContent = T.cockpit.cancelling;
    try {
      await ensureCancelReasons();           // Loop needs a cancellationFlowId
      var flowId = pickDefaultCancelFlowId();
      var body = {};
      if (flowId != null) body.cancellationFlowId = flowId;
      if (comment) body.comment = comment;    // free-text reason → Loop
      await apiFetch('/subscription/' + state.subscription.id + '/cancel', {
        method: 'POST',
        body: body,
      });
      // Store the free-text reason in Supabase (subscription_events).
      logSubscriptionEvent({
        event_type: 'cancel',
        subscription_id: state.subscription.id,
        reason_key: 'free_text',
        reason_label: null,
        comment: comment || null,
      });
      closeDialog('confirm-dialog');
      await loadData();
    } catch (e) {
      btn.textContent = T.cockpit.cancel_retry || 'Fehler – erneut versuchen';
      btn.disabled = false;
    }
  }

  // ============================================================
  // TOAST
  // ============================================================

  var _toastTimer = null;
  function showToast(message, actionLabel, onAction) {
    var t = document.getElementById('tt-cp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'tt-cp-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    t.appendChild(span);
    if (actionLabel && onAction) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = actionLabel;
      btn.addEventListener('click', function () { onAction(); hideToast(); });
      t.appendChild(btn);
    }
    requestAnimationFrame(function () { t.classList.add('open'); });
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(hideToast, 5000);
  }
  function hideToast() {
    var t = document.getElementById('tt-cp-toast');
    if (t) t.classList.remove('open');
  }

  // ============================================================
  // CHANNEL + KLAVIYO
  // ============================================================

  function selectChannel(btn) {
    var group = btn.closest('[role="group"]');
    group.querySelectorAll('.channel-btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    btn.setAttribute('aria-pressed', 'true');
    var channel = btn.dataset.channel;
    var needsPhone = channel === 'whatsapp' || channel === 'both';
    var fields = document.getElementById('whatsapp-fields');
    if (needsPhone) {
      fields.hidden = false;
      fields.style.maxHeight = fields.scrollHeight + 120 + 'px';
      fields.style.opacity = '1';
    } else {
      fields.style.maxHeight = '0';
      fields.style.opacity = '0';
      setTimeout(function () { if (fields.style.maxHeight === '0' || fields.style.maxHeight === '0px') fields.hidden = true; }, 350);
    }
    flashUnsaved();
  }
  function flashUnsaved() {
    var el = document.getElementById('save-status');
    if (el) el.innerHTML = T.cockpit.unsaved_changes_dot_html;
  }

  function flashSavedStart() {
    var el = document.getElementById('save-status');
    if (el) el.innerHTML = '<span style="color:var(--green);">⟳</span> ' + esc(T.cockpit.saving_dots);
  }
  function flashSavedDone() {
    var el = document.getElementById('save-status');
    if (el) el.innerHTML = '<span aria-hidden="true" style="color:var(--green);">✓</span> ' + esc(T.cockpit.saved_seconds_ago);
  }
  function flashSavedError(msg) {
    var el = document.getElementById('save-status');
    if (el) el.innerHTML = '<span style="color:var(--red);">⚠</span> ' + esc(msg || T.common.error);
  }

  async function saveChannelPreference(channel) {
    var KLAVIYO_PK = 'W6nU28';
    var KLAVIYO_LIST = 'S2vieK';
    var KLAVIYO_REV = '2025-07-15';
    var email = state.customer ? state.customer.email : '';
    if (!email) throw new Error(T.cockpit.no_email_short);
    var phoneInput = document.getElementById('whatsapp-number');
    var phoneRaw = phoneInput ? phoneInput.value.trim() : '';
    var needsPhone = channel === 'whatsapp' || channel === 'both';
    var phone = '';
    if (needsPhone) {
      if (!phoneRaw) throw new Error(T.cockpit.phone_missing);
      phone = phoneRaw.replace(/[\s\-\(\)]/g, '');
      if (phone.indexOf('00') === 0) phone = '+' + phone.slice(2);
      if (phone.indexOf('0') === 0) phone = '+41' + phone.slice(1);
      if (phone.indexOf('+') !== 0) phone = '+' + phone;
      if (!/^\+[1-9]\d{7,14}$/.test(phone)) throw new Error(T.cockpit.addr_invalid_phone);
    }

    var profileAttrs = { email: email, properties: { marketing_channel: channel, wa_phone: phone || null } };
    if (phone) profileAttrs.phone_number = phone;

    var r1 = await fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_PK, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': KLAVIYO_REV },
      body: JSON.stringify({ data: { type: 'profile', attributes: profileAttrs } })
    });
    if (!r1.ok && r1.status !== 202) throw new Error('Profile-Update: ' + r1.status);

    await fetch('https://a.klaviyo.com/client/events?company_id=' + KLAVIYO_PK, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': KLAVIYO_REV },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Channel Preference Updated' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: { marketing_channel: channel }
          }
        }
      })
    });

    if (needsPhone && phone) {
      await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_PK, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': KLAVIYO_REV },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    phone_number: phone,
                    subscriptions: { whatsapp: { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
          }
        })
      });
    }

    try { localStore.setItem('tt_marketing_channel', channel); } catch (e) {}
    if (state.profile) state.profile.marketing_channel = channel;
  }

  // ============================================================
  // COCKPIT SUB-NAV scroll-spy
  // ============================================================

  function initCockpitNav() {
    var sideNav = document.getElementById('cockpit-side-nav');
    if (!sideNav) return;
    // Always show side-nav
    sideNav.hidden = false;
    document.body.classList.add('tt-cp-side-nav');

    var sideItems = Array.from(sideNav.querySelectorAll('.cockpit-side-nav-item'));
    var sections = sideItems.map(function (a) {
      var id = a.dataset.target;
      return { id: id, el: document.getElementById(id) };
    }).filter(function (s) { return s.el; });

    var SIDENAV_DEFAULT_TOP = 284; // px — keep in sync with .cockpit-side-nav top
    var SIDENAV_STOP_MARGIN = 24;  // px breathing room above contact section
    var stopTarget = document.getElementById('nav-support')
      || document.querySelector('.contact-section');

    function updateSidebarPos() {
      if (sideNav.hidden || !stopTarget) return;
      // Hidden by media query at <=1100px — bail out
      if (getComputedStyle(sideNav).display === 'none') {
        sideNav.style.position = '';
        sideNav.style.top = '';
        return;
      }
      var sidebarH = sideNav.offsetHeight;
      var stopRect = stopTarget.getBoundingClientRect();
      var stopDocY = stopRect.top + window.scrollY;
      var maxDocY = stopDocY - sidebarH - SIDENAV_STOP_MARGIN;
      var fixedDocY = window.scrollY + SIDENAV_DEFAULT_TOP;
      if (fixedDocY < maxDocY) {
        sideNav.style.position = 'fixed';
        sideNav.style.top = SIDENAV_DEFAULT_TOP + 'px';
      } else {
        sideNav.style.position = 'absolute';
        sideNav.style.top = maxDocY + 'px';
      }
    }

    function updateActive() {
      if (sideNav.hidden) return;
      var activeIdx = 0;
      // At top of page, always highlight the first section.
      if (window.scrollY <= 8) {
        activeIdx = 0;
      } else {
        var lineY = window.innerHeight * 0.28;
        for (var i = 0; i < sections.length; i++) {
          var r = sections[i].el.getBoundingClientRect();
          if (r.top <= lineY) activeIdx = i;
          else break;
        }
        var scrollable = document.body.scrollHeight > window.innerHeight + 40;
        if (scrollable && (window.innerHeight + window.scrollY) >= document.body.scrollHeight - 40) {
          activeIdx = sections.length - 1;
        }
      }
      var activeId = sections[activeIdx] ? sections[activeIdx].id : null;
      sideItems.forEach(function (it) { it.classList.toggle('is-active', it.dataset.target === activeId); });
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateActive();
          updateSidebarPos();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', function () {
      updateActive();
      updateSidebarPos();
    }, { passive: true });
    updateActive();
    updateSidebarPos();
    // Dynamic content (dishes/planned/history) renders after init — recalc once stable.
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { updateSidebarPos(); });
      ro.observe(document.body);
    } else {
      [100, 400, 1000, 2500].forEach(function (ms) { setTimeout(updateSidebarPos, ms); });
    }

    sideItems.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.dataset.target;
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        var top = el.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
      });
    });
  }

  // ============================================================
  // EVENT DELEGATION
  // ============================================================

  function bindOnce() {
    // Dialog close buttons + backdrop click
    document.querySelectorAll('.dialog-overlay').forEach(function (d) {
      d.addEventListener('click', function (e) {
        if (e.target === d) closeDialog(d.id);
      });
    });
    document.querySelectorAll('[data-close-dialog]').forEach(function (b) {
      b.addEventListener('click', function () {
        closeDialog(b.dataset.closeDialog);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDialogs();
    });

    // Info tooltip: tap-to-toggle for touch devices (hover/focus handle desktop)
    document.querySelectorAll('.info-tip').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = t.classList.toggle('is-open');
        document.querySelectorAll('.info-tip.is-open').forEach(function (o) {
          if (o !== t) o.classList.remove('is-open');
        });
        if (!open) t.blur();
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') t.classList.remove('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.info-tip')) {
        document.querySelectorAll('.info-tip.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      }
    });

    // Merchant impersonation exit
    var mvExit = document.getElementById('merchant-view-exit');
    if (mvExit) mvExit.addEventListener('click', exitMerchantView);

    // Hero buttons
    document.getElementById('btn-resume').addEventListener('click', resumeSubscription);
    document.getElementById('btn-pause-adjust').addEventListener('click', openPauseDialog);
    document.getElementById('btn-reactivate').addEventListener('click', function (e) {
      reactivateSubscription(e.currentTarget);
    });
    document.body.addEventListener('click', function (e) {
      var reEl = e.target.closest('[data-action="reactivate"]');
      if (reEl) { e.preventDefault(); reactivateSubscription(reEl); }
      var rsEl = e.target.closest('[data-action="resume"]');
      if (rsEl) { e.preventDefault(); resumeSubscription(); }
    });
    document.getElementById('btn-skip-next').addEventListener('click', function () {
      // Restore mode: the shown (coming) delivery is already skipped → un-skip it.
      if (this.dataset.mode === 'restore') {
        if (state.comingOrder) unskipOrder(state.comingOrder.id);
        return;
      }
      skipUpcomingDelivery();
    });
    // Übergabe ins neue Tom Tasty (E-65): Die Loop-Sitzung geht an den neuen
    // Shop, der bei Loop prüft, wer das ist, und einen einmaligen Anmelde-Link
    // zurückgibt. Scheitert etwas, führt der Weg auf die Anmeldung mit Code.
    // Zwei Knöpfe (Band oben, Umzugs-Karte), dieselbe Übergabe.
    async function neuUebergabe(neuBtn) {
      var ribbon = document.getElementById('neu-ribbon') || document.getElementById('neu-umzug');
      var basis = ((ribbon && ribbon.getAttribute('data-basis')) || 'https://app.tomtasty.ch').replace(/\/$/, '');
      var sprache = (TT_LOCALE || 'de').slice(0, 2).toLowerCase();
      var praefix = sprache === 'de' ? '' : '/' + sprache;
      var ersatz = basis + praefix + '/konto/umzug';
      neuBtn.disabled = true;
      try {
        var token = await getValidToken();
        var res = await fetch(basis + '/api/umzug/uebergabe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token || '', sprache: sprache }),
        });
        var data = res.ok ? await res.json() : null;
        window.location.href = (data && typeof data.url === 'string' && data.url.indexOf(basis) === 0) ? data.url : ersatz;
      } catch (e) {
        window.location.href = ersatz;
      }
    }
    ['neu-ribbon-btn', 'neu-umzug-btn'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', function () { neuUebergabe(btn); });
    });
    // «Später»: Umzugs-Karte 7 Tage ausblenden, das Band oben bleibt.
    var neuSpaeter = document.getElementById('neu-umzug-spaeter');
    if (neuSpaeter) neuSpaeter.addEventListener('click', function () {
      localStore.setItem(NEU_UMZUG_SPAETER_KEY, String(Date.now() + NEU_UMZUG_SPAETER_MS));
      var karte = document.getElementById('neu-umzug');
      if (karte) karte.hidden = true;
    });

    document.getElementById('btn-hero-pause').addEventListener('click', openPauseDialog);
    document.getElementById('btn-adjust-dishes').addEventListener('click', function (e) {
      e.preventDefault();
      if (state.subscription) window.location.href = localized('/pages/selector?sub=' + encodeURIComponent(state.subscription.id));
    });
    document.getElementById('link-adjust-dishes').addEventListener('click', function (e) {
      e.preventDefault();
      if (state.subscription) window.location.href = localized('/pages/selector?sub=' + encodeURIComponent(state.subscription.id));
    });

    // Cancel is a discreet link in the page footer (next to logout).
    // The pre-cancel video (Tina) is German-only, so for non-DE locales
    // (EN/FR/…) we skip the video screen and go straight to the cancel step.
    document.getElementById('link-open-cancel').addEventListener('click', function () {
      if (TT_LOCALE === 'de-CH') {
        openPreCancelDialog();
      } else {
        openCancelDialog();
      }
    });
    document.getElementById('pre-cancel-continue').addEventListener('click', function () {
      closePreCancelDialog();
      openCancelDialog();
    });
    document.getElementById('pre-cancel-sound-toggle').addEventListener('click', function () {
      var video = document.getElementById('pre-cancel-video');
      if (!video) return;
      var muted = !video.muted;
      video.muted = muted;
      this.classList.toggle('is-muted', muted);
      this.setAttribute('aria-pressed', String(!muted));
      this.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
      if (!muted) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* ignore */ });
      }
    });

    // Skip confirm
    document.getElementById('skip-confirm-btn').addEventListener('click', confirmSkip);

    // Pause dialog interactions
    document.querySelectorAll('.pause-week').forEach(function (w) {
      w.addEventListener('click', function () { setPauseWeeks(parseInt(w.dataset.weeks, 10)); });
    });
    document.getElementById('pause-confirm-btn').addEventListener('click', confirmPause);

    // Address
    document.getElementById('link-edit-address').addEventListener('click', function (e) { e.preventDefault(); openAddressDialog(); });
    document.getElementById('address-dialog-form').addEventListener('submit', function (e) { e.preventDefault(); saveAddress(); });

    // Payment
    document.getElementById('link-edit-payment').addEventListener('click', function (e) { e.preventDefault(); openPaymentDialog(); });
    document.getElementById('pm-list').addEventListener('click', function (e) {
      var radio = e.target.closest('[data-set-primary]');
      if (!radio) return;
      setPrimaryPaymentMethod(radio.dataset.setPrimary);
    });
    var updateBtn = document.getElementById('pm-update-btn');
    if (updateBtn) {
      updateBtn.addEventListener('click', sendPaymentUpdateMail);
    }

    // Cancel — single free-text step (after the Tina pre-cancel video).
    document.getElementById('final-cancel-btn').addEventListener('click', finalCancel);

    // Retention alternatives in the cancel dialog — route to the existing
    // pause / skip flows instead of cancelling.
    var keepPauseBtn = document.getElementById('cancel-keep-pause');
    if (keepPauseBtn) keepPauseBtn.addEventListener('click', function () {
      closeDialog('confirm-dialog');
      openPauseDialog();
    });
    var keepSkipBtn = document.getElementById('cancel-keep-skip');
    if (keepSkipBtn) keepSkipBtn.addEventListener('click', function () {
      closeDialog('confirm-dialog');
      skipUpcomingDelivery();
    });

    // Reason box (skip/pause)
    var reasonOptions = document.getElementById('reason-options');
    if (reasonOptions) {
      reasonOptions.addEventListener('click', function (e) {
        var btn = e.target.closest('.cancel-reason');
        if (btn && btn.dataset.reasonKey) selectReason(btn.dataset.reasonKey);
      });
    }
    var reasonSubmitBtn = document.getElementById('reason-submit-btn');
    if (reasonSubmitBtn) reasonSubmitBtn.addEventListener('click', submitReason);

    // Channel selector
    document.querySelectorAll('.channel-btn').forEach(function (b) {
      b.addEventListener('click', function () { selectChannel(b); });
    });
    var phoneInput = document.getElementById('whatsapp-number');
    if (phoneInput) {
      phoneInput.addEventListener('input', flashUnsaved);
    }

    // Manual save button in Benachrichtigungen
    var saveBtn = document.getElementById('btn-save-notifications');
    if (saveBtn) {
      saveBtn.addEventListener('click', async function () {
        var active = document.querySelector('.channel-btn[aria-pressed="true"]');
        if (!active) return;
        saveBtn.classList.add('btn-loading');
        flashSavedStart();
        try {
          await saveChannelPreference(active.dataset.channel);
          flashSavedDone();
        } catch (e) {
          flashSavedError(e.message);
        } finally {
          saveBtn.classList.remove('btn-loading');
        }
      });
    }

    // Coupon events (delegated)
    document.getElementById('coupon-list').addEventListener('click', function (e) {
      var rem = e.target.closest('[data-remove-coupon]');
      if (rem) {
        var row = rem.closest('.coupon-row');
        var id = row.dataset.couponId;
        var code = row.dataset.couponCode;
        var label = row.dataset.couponLabel;
        openCouponRemoveDialog(id, code, label);
        return;
      }
      var cpy = e.target.closest('.code-copy');
      if (cpy) {
        var codeStr = cpy.dataset.code;
        if (!codeStr) return;
        navigator.clipboard.writeText(codeStr).then(function () {
          var codeEl = cpy.querySelector('code');
          var original = codeEl.textContent;
          cpy.classList.add('copied');
          codeEl.textContent = 'Kopiert!';
          setTimeout(function () {
            cpy.classList.remove('copied');
            codeEl.textContent = original;
          }, 1600);
        }).catch(function () {});
      }
    });

    // Coupon redeem
    var codeInput = document.getElementById('coupon-code-input');
    var redeemBtn = document.getElementById('coupon-redeem-btn');
    codeInput.addEventListener('input', function () {
      codeInput.value = codeInput.value.toUpperCase();
      redeemBtn.disabled = !codeInput.value.trim();
    });
    redeemBtn.addEventListener('click', async function () {
      if (!state.subscription) return;
      redeemBtn.classList.add('btn-loading');
      redeemBtn.disabled = true;
      try {
        await apiFetch('/subscription/' + state.subscription.id + '/applyDiscount', {
          method: 'POST',
          body: { discountCode: codeInput.value.trim() },
        });
        codeInput.value = '';
        await loadData();
        showToast(T.cockpit.coupon_redeemed);
      } catch (e) {
        showToast(T.cockpit.coupon_failed);
      } finally {
        redeemBtn.classList.remove('btn-loading');
      }
    });

    // Planned deliveries (delegated skip/unskip)
    document.getElementById('planned-list-near').addEventListener('click', handleDeliveryClick);
    document.getElementById('delivery-extra').addEventListener('click', handleDeliveryClick);

    // Toggle extended deliveries
    document.getElementById('toggle-deliveries').addEventListener('click', function (e) {
      e.preventDefault();
      state.deliveriesExpanded = !state.deliveriesExpanded;
      renderPlannedDeliveries();
    });

    // Order accordion + per-dish review controls (delegated)
    document.getElementById('order-history-list').addEventListener('click', function (e) {
      var rateBtn = e.target.closest('[data-rate-product]');
      if (rateBtn) {
        e.preventDefault();
        e.stopPropagation();
        openReviewForLine(rateBtn.getAttribute('data-rate-order'), rateBtn.getAttribute('data-rate-product'));
        return;
      }
      var head = e.target.closest('[data-order-toggle]');
      if (head) {
        e.preventDefault();
        toggleOrderExpand(head.getAttribute('data-order-toggle'));
      }
    });
    // Keyboard activation for the role="button" accordion heads
    document.getElementById('order-history-list').addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var head = e.target.closest('[data-order-toggle]');
      if (!head) return;
      e.preventDefault();
      toggleOrderExpand(head.getAttribute('data-order-toggle'));
    });

    // Order history pagers + expand/collapse (delegated, rebind per render)
    document.getElementById('order-history-footer').addEventListener('click', function (e) {
      if (e.target.id === 'expand-orders') { state.ordersExpanded = true; state.ordersPage = 1; renderOrderHistory(); return; }
      if (e.target.id === 'collapse-orders') { state.ordersExpanded = false; renderOrderHistory(); return; }
      var pageBtn = e.target.closest('[data-opage]');
      if (!pageBtn) return;
      var totalPages = Math.max(1, Math.ceil(state.orders.length / PAGE_SIZE));
      var v = pageBtn.dataset.opage;
      if (v === 'prev') state.ordersPage = Math.max(1, state.ordersPage - 1);
      else if (v === 'next') state.ordersPage = Math.min(totalPages, state.ordersPage + 1);
      else state.ordersPage = parseInt(v, 10);
      renderOrderHistory();
    });

    // Review modal — stars, tags, submit
    var reviewModal = document.getElementById('review-modal');
    if (reviewModal) {
      document.getElementById('review-stars').addEventListener('click', function (e) {
        var b = e.target.closest('[data-rating]');
        if (!b) return;
        setReviewRating(parseInt(b.dataset.rating, 10));
      });
      document.getElementById('review-tags').addEventListener('click', function (e) {
        var b = e.target.closest('[data-tag-label]');
        if (!b) return;
        applyChipToComment(b.dataset.tagLabel);
      });
      // Manual edits in the textarea should keep chip active states in sync.
      document.getElementById('review-comment').addEventListener('input', function () {
        syncChipStatesFromComment();
      });
      document.getElementById('review-submit-btn').addEventListener('click', function () {
        submitActiveReview();
      });
      // "Später" skips the current dish and shows the next one instead of
      // closing the modal. On the last dish this ends the queue, which also
      // triggers the Google-review prompt for the dishes rated this session.
      var laterBtn = document.getElementById('review-later-btn');
      if (laterBtn) laterBtn.addEventListener('click', function () {
        if (state.activeReview && state.activeReview.saving) return;
        advanceReviewQueue();
      });
      reviewModal.addEventListener('click', function (e) {
        // Clicking outside the dialog (on the overlay) discards the queue.
        if (e.target === reviewModal && !(state.activeReview && state.activeReview.saving)) {
          state.activeReview = null;
          state.reviewQueue = null;
        }
      });
    }

    // Google-review flyover
    var grCta = document.getElementById('google-review-cta');
    if (grCta) grCta.addEventListener('click', goToGoogleReview);
    var grDone = document.getElementById('google-review-done');
    if (grDone) grDone.addEventListener('click', function () { resolveGoogleReview('done'); });
    var grLater = document.getElementById('google-review-later');
    if (grLater) grLater.addEventListener('click', function () { resolveGoogleReview('later'); });

    // Dish pager
    document.getElementById('dish-pager').addEventListener('click', function (e) {
      var b = e.target.closest('[data-dpage]'); if (!b) return;
      var lines = state.subscription ? (state.subscription.lines || []) : [];
      var totalPages = Math.max(1, Math.ceil(lines.length / DISH_PAGE_SIZE));
      var v = b.dataset.dpage;
      if (v === 'prev') state.dishPage = Math.max(1, state.dishPage - 1);
      else if (v === 'next') state.dishPage = Math.min(totalPages, state.dishPage + 1);
      else state.dishPage = parseInt(v, 10);
      render();
    });

    // Logout
    document.getElementById('btn-logout').addEventListener('click', function () {
      clearTokens();
      goToLogin();
    });

    // Deadline refresh
    setInterval(function () {
      var sub = state.subscription;
      if (!sub) return;
      var sched = getDeadlineAndDelivery(sub.nextBillingDate);
      updateDeadlineBadge(sched.deadline);
    }, 30000);
  }

  function handleDeliveryClick(e) {
    var skip = e.target.closest('[data-skip]');
    if (skip) {
      e.preventDefault();
      openSkipDialog(skip.dataset.skip, skip.dataset.date);
      return;
    }
    var unskip = e.target.closest('[data-unskip]');
    if (unskip) {
      e.preventDefault();
      unskipOrder(unskip.dataset.unskip);
    }
  }

  async function unskipOrder(orderId) {
    try {
      await apiFetch('/order/' + orderId + '/unskip', { method: 'POST' });
      await loadData();
    } catch (e) {
      showToast(T.cockpit.restore_failed);
    }
  }

  // ============================================================
  // LOAD DATA
  // ============================================================

  async function loadData(opts) {
    var silentRefresh = !!(opts && opts.silentRefresh);
    if (!silentRefresh) showView('loading');

    // EN/FR: übersetzte Gerichte-Titel parallel zu den Loop-Calls laden
    // (auf DE ein sofort aufgelöstes Promise, kein Request).
    var dishTitlesReady = loadTranslatedDishTitles();

    // Früh festhalten — tryScrollToReviewsAfterSave() entfernt den Parameter
    // später aus der URL.
    var cameFromDishes = new URLSearchParams(window.location.search).get('from') === 'dishes';

    // Preview mode for the Google-review flyover: ?googleReviewPreview=1
    // (or ?preview=google-review). Forces the flyover on load and disables its
    // DB writes, so it can be inspected without meeting the real conditions.
    (function () {
      var p = new URLSearchParams(window.location.search);
      var v = p.get('googleReviewPreview');
      state.googleReviewPreview = v === '1' || v === 'true'
        || p.get('preview') === 'google-review';
    })();

    // Auth resolution order:
    //   1. URL has ?sessionToken=… (Klaviyo magic-link landing) → exchange for
    //      an (access, refresh) pair, strip the token from the URL.
    //   2. Stored refresh token can rotate → keep current session alive
    //      without any user interaction.
    //   3. Neither works → bounce to the login page with a reason so it can
    //      render the right banner.
    // 0. Loop admin impersonation entry (?merchantToken=…). Takes precedence:
    //    it discards any existing session so we never render the wrong customer.
    var isMerchant = tryUrlMerchantToken();
    var urlExchange = isMerchant ? null : await tryUrlSessionTokenExchange();
    // Persisted impersonation: keep the banner across reloads / navigating back
    // to the cockpit, even though the merchantToken is no longer in the URL.
    state.isMerchantView = localStore.getItem(STORAGE.merchantView) === '1';
    if (urlExchange === false) {
      // Token was on the URL but Loop rejected it (expired, malformed, etc.).
      // The stored refresh token may still be valid though, so fall through
      // to the standard token check before bouncing.
      logAuth('fallback', { reason: 'session_expired_with_stored_check' });
    }

    var token = await getValidToken();
    if (!token) {
      if (urlExchange === false) {
        goToLogin('session_expired');
      } else {
        logAuth('fallback', { reason: 'no_token' });
        goToLogin('no_token');
      }
      return;
    }
    if (urlExchange === true) {
      logAuth('autologin', { source: 'url_session_token' });
    } else {
      // urlExchange is either null (no token on URL) or false (URL token
      // failed but stored credentials carried us through). Both count as
      // "session resumed without user interaction".
      logAuth('autologin', { source: 'stored_session' });
    }

    try {
      var results = await Promise.all([
        apiFetch('/customer').catch(function () { return null; }),
        apiFetch('/subscription').catch(function () { return null; }),
        apiFetch('/paymentMethod').catch(function () { return null; }),
      ]);

      state.customer = results[0];
      var subData = results[1];
      var subs = Array.isArray(subData) ? subData : (subData && subData.subscriptions ? subData.subscriptions : []);
      subs.sort(function (a, b) {
        var da = new Date(a.createdAt || a.nextBillingDate || 0);
        var db = new Date(b.createdAt || b.nextBillingDate || 0);
        return db - da;
      });
      state.subscription = subs.find(function (s) { return s.status === 'ACTIVE'; })
        || subs.find(function (s) { return s.status === 'PAUSED'; })
        || subs[0] || null;

      var pmData = results[2];
      state.paymentMethods = Array.isArray(pmData) ? pmData : (pmData && pmData.paymentMethods ? pmData.paymentMethods : []);

      var parallelFetches = [];
      if (state.subscription) {
        parallelFetches.push(
          apiFetch('/subscription/' + state.subscription.id + '/order/history').catch(function () { return null; }),
          apiFetch('/subscription/' + state.subscription.id + '/order/schedule').catch(function () { return null; })
        );
      } else {
        parallelFetches.push(Promise.resolve(null), Promise.resolve(null));
      }

      var allResults = await Promise.all(parallelFetches);
      var orderData = allResults[0];
      state.orders = Array.isArray(orderData) ? orderData : (orderData && orderData.orders ? orderData.orders : []);
      var scheduleData = allResults[1];
      state.scheduledOrders = Array.isArray(scheduleData) ? scheduleData : (scheduleData && scheduleData.orders ? scheduleData.orders : []);

      // Load this customer's reviews. Non-blocking: if Supabase is down or the
      // Loop token is invalid, the cockpit still renders — every dish just looks
      // unrated. We re-render order history afterwards so the badges/stars
      // appear once the data arrives.
      supabaseFetch('/my-reviews').then(function (resp) {
        state.reviews = (resp && Array.isArray(resp.reviews)) ? resp.reviews : [];
        state._reviewsLoaded = true;
        if (document.getElementById('order-history-list')) renderOrderHistory();
        tryScrollToReviewsAfterSave();
      }).catch(function (err) {
        console.warn('my-reviews failed', err);
      });

      // Load the customer's Google-review prompt state. Non-blocking: if it
      // hasn't resolved by the time a review session ends, googleReviewEligible()
      // simply treats it as "never asked" (worst case: one extra prompt).
      supabaseFetch('/google-review').then(function (resp) {
        state.googleReview = (resp && resp.prompt) ? resp.prompt : null;
        state._googleReviewLoaded = true;
      }).catch(function (err) {
        console.warn('google-review status failed', err);
      });

      state.profile = null;

      // If the customer just came back from a Loop email-update flow, Loop
      // has a fresh pmId in /paymentMethod that the subscription isn't yet
      // billing against. Promote it once before rendering so the cockpit
      // shows (and Loop bills) the new card on the very next page load.
      await autoPromoteNewestPaymentMethod();

      // Die Titel-Map ist normalerweise längst da (ein CDN-Fetch vs. mehrere
      // Loop-API-Calls). Hart auf 3s begrenzt, damit ein hängender Request
      // das Cockpit nie blockiert — dann rendert es mit den Loop-Titeln.
      await Promise.race([dishTitlesReady, new Promise(function (r) { setTimeout(r, 3000); })]);

      render();
      showView('content');
      tryScrollToReviewsAfterSave();
      if (cameFromDishes) scheduleStaleDishRecheck();
      // Preview mode: show the Google-review flyover once the cockpit is up.
      if (state.googleReviewPreview) {
        setTimeout(function () { openGoogleReviewFlyover({ preview: true }); }, 400);
      }
    } catch (e) {
      console.error('Cockpit error:', e);
      if (silentRefresh) {
        // A background refresh after an already-successful save failed —
        // don't blow away the still-rendered cockpit with the full-page
        // error screen. Leave the view as-is; it'll catch up on the next
        // natural reload.
        return;
      }
      elError.innerHTML = '<div class="tt-cp__error"><div class="tt-cp__error-icon">😕</div>'
        + '<p>' + esc(T.cockpit.loading_data_failed) + '</p>'
        + '<button onclick="location.reload()">' + esc(T.cockpit.error_retry) + '</button></div>';
      showView('error');
    }
  }

  // ============================================================
  // DISH PHOTO LIGHTBOX
  // ============================================================
  // Tap on a dish image or name (inside the past-deliveries accordion) to see
  // the full-size photo. Backdrop click, ✕ button, and Escape close it.
  // Skipped: clicks on the rate-button / stars on the right column — those
  // already stop propagation upstream so this listener never sees them.

  function bindDishLightbox() {
    var modal = document.getElementById('dish-lightbox');
    if (!modal) return;
    var img = document.getElementById('dish-lightbox-img');
    var cap = document.getElementById('dish-lightbox-caption');

    function open(src, name) {
      if (!src) return;
      img.src = src;
      img.alt = name || '';
      cap.textContent = name || '';
      modal.hidden = false;
      // Force a reflow before adding the open class so the transition fires.
      // requestAnimationFrame is throttled in background tabs and can leave the
      // overlay sitting at opacity:0 indefinitely; reading offsetHeight forces
      // the browser to flush the just-applied hidden=false state synchronously.
      void modal.offsetHeight;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (window.TTHistory) window.TTHistory.open('dish-lightbox', close);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; img.src = ''; }, 200);
      if (window.TTHistory) window.TTHistory.close('dish-lightbox');
    }

    document.addEventListener('click', function (e) {
      // Open: tap on the dish card inside the review modal
      if (e.target.closest('.review-dish-card')) {
        var src = document.getElementById('review-dish-img').getAttribute('src');
        var name = document.getElementById('review-dish-name').textContent.trim();
        if (src) open(src, name);
        return;
      }
      // Close: backdrop or ✕
      if (e.target.closest('[data-action="close-dish-photo"]') || e.target === modal) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  // ============================================================
  // INIT
  // ============================================================

  // Debug surface for inspecting Loop's order/line shape and review state.
  // Strictly read-only — safe to leave on. Remove once we have confidence
  // that lineProductId is picking up the right field for every customer.
  window.__ttCockpit = {
    state: state,
    lineProductId: lineProductId,
    findReview: findReview,
    progress: reviewProgress,
    inspectOrder: function (i) {
      var o = (state.orders || [])[i || 0];
      if (!o) return null;
      var lines = o.lines || o.lineItems || [];
      return {
        id: o.id,
        status: o.status,
        orderKeys: Object.keys(o),
        lineCount: lines.length,
        lineKeys: lines[0] ? Object.keys(lines[0]) : [],
      };
    },
    inspectLine: function (orderIdx, lineIdx) {
      var o = (state.orders || [])[orderIdx || 0];
      if (!o) return null;
      var lines = o.lines || o.lineItems || [];
      var l = lines[lineIdx || 0];
      if (!l) return null;
      return {
        productId: lineProductId(l),
        line: l,
      };
    },
  };

  bindOnce();
  initCockpitNav();
  bindDishLightbox();
  loadData();

})();
